// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-09T16:41:00.449Z
// Property: Alon at Castle Hills (ID: 5735011386916864)
// Collections: 22 amenities, 9 floorplans (live), 13 photos, 78 POIs, 3 reviews, 6 virtual tours, 6 office hours, 1 special offers (live), 18 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5735011386916864",
  "property_external_id": "4489149",
  "property_zillow_url": "https://www.zillow.com/apartments/san-antonio-tx/1835-lockhill.dash.selma-rd/5XkVgD/",
  "property_apartments_url": "https://www.apartments.com/alon-at-castle-hills-san-antonio-tx/sfj39d4",
  "property_google_business_url": "https://www.google.com/maps/place/Alon+at+Castle+Hills/@29.5375103,-98.5219518,15z/data=!4m2!3m1!1s0x0:0xcb5fad46bb3283f1?sa=X&ved=2ahUKEwictu_Gy-H2AhX1rmoFHSLFCksQ_BJ6BAgnEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443218213",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "alon-at-castle-hills",
  "property_name": "Alon at Castle Hills",
  "property_website_url": "https://www.alonatcastlehills.com/",
  "property_domain": "https://www.alonatcastlehills.com/",
  "property_address": "1835 Lockhill Selma Rd",
  "property_full_address": "1835 Lockhill Selma Rd, San Antonio, TX 78213",
  "property_address_1": "1835 Lockhill Selma Rd",
  "property_address_2": null,
  "property_address_city": "Castle Hills",
  "property_address_state": "TX",
  "property_address_zip_full": "78213-1505",
  "property_address_zip": "78213",
  "property_address_country": "US",
  "property_address_county": "Bexar County",
  "property_neighborhood_address": "San Antonio International Airport Vicinity",
  "property_address_latitude": "29.53773289999999",
  "property_address_longitude": "-98.5215882",
  "property_email": "alon@alapts.com",
  "property_phone": "(210) 342-5151",
  "property_call_tracking_phone": "210-874-0910",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Polished North Central San Antonio apartments with everyday ease.</strong> Explore one- and two-bedroom layouts with chef’s kitchens, stainless steel appliances, hardwood-style flooring, walk-in closets, and private patios or balconies—then schedule your tour at Alon at Castle Hills.</p>",
  "property_long_description": "<p><strong>North Central San Antonio convenience meets polished everyday comfort at Alon at Castle Hills.</strong> Choose from one- and two-bedroom <a href=\"/floor-plans\">apartment layouts</a> with chef’s kitchens, stainless steel appliances, hardwood-style flooring, washer/dryer connections, walk-in closets, and private patios or balconies.</p><p>Outside your door, <a href=\"/amenities\">community amenities</a> make it easy to reset: take a dip in the resort-style pool, work out any time in the 24-hour fitness center, settle into the clubhouse, business center, cyber café, billiards lounge, or movie theater, and make use of gated access, LUXER package lockers, garage options, storage, online resident services, and the on-site dog park.</p><p>Set near Castle Hills in the San Antonio International Airport vicinity, you’re close to Alon Market H-E-B, North Star Mall, Phil Hardberger Park’s trails and dog parks, and quick routes via I-10, Loop 410, and Highway 281 for reaching the Medical Center, downtown, and the rest of San Antonio.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019d02f3-76d6-7491-82d0-8d0ccd995ad7.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool with fountains and seating area.",
    "public_id": "019d02f3-76d6-7491-82d0-8d0ccd995ad7",
    "storage_key": "property/5735011386916864/019d02f3-76d6-7491-82d0-8d0ccd995ad7.webp",
    "width": 1240,
    "height": 825
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "306",
  "property_year_built": "2000",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.42483660130719",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Pet Fee: $300/pet Non-Refundable\nMonthly Pet Rent: $20/pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://7763081.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://alonatcastlehills.loftliving.com/login",
  "property_apply_now_url": "https://7763081.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019df5cc-76f4-726c-9d4f-f840758cffc2.webp",
  "property_primary_logo_media": {
    "alt_text": "Alon at Castle Hills Premier Apartments logo",
    "public_id": "019df5cc-76f4-726c-9d4f-f840758cffc2",
    "storage_key": "property/5735011386916864/019df5cc-76f4-726c-9d4f-f840758cffc2.webp",
    "width": 855,
    "height": 801
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019df5cc-7756-7291-9fec-4f8966ff75b0.webp",
  "property_secondary_logo_media": {
    "alt_text": "ALON at Castle Hills Premier Apartments logo.",
    "public_id": "019df5cc-7756-7291-9fec-4f8966ff75b0",
    "storage_key": "property/5735011386916864/019df5cc-7756-7291-9fec-4f8966ff75b0.webp",
    "width": 744,
    "height": 781
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019df5cc-773e-739d-a866-bdd2bf0246d0.webp",
  "property_icon_media": {
    "alt_text": "Abstract purple and brown logo",
    "public_id": "019df5cc-773e-739d-a866-bdd2bf0246d0",
    "storage_key": "property/5735011386916864/019df5cc-773e-739d-a866-bdd2bf0246d0.webp",
    "width": 481,
    "height": 481
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019df5cc-773e-739d-a866-bdd2bf0246d0.webp",
  "property_fav_icon_media": {
    "alt_text": "Abstract purple and brown logo",
    "public_id": "019df5cc-773e-739d-a866-bdd2bf0246d0",
    "storage_key": "property/5735011386916864/019df5cc-773e-739d-a866-bdd2bf0246d0.webp",
    "width": 481,
    "height": 481
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1931-ebbc-7429-8492-4f79036c9460.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f1931-ebbc-7429-8492-4f79036c9460",
    "storage_key": "property/5735011386916864/019f1931-ebbc-7429-8492-4f79036c9460.webp",
    "width": 855,
    "height": 801
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1931-d683-7528-8674-a3262cc890f0.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f1931-d683-7528-8674-a3262cc890f0",
    "storage_key": "property/5735011386916864/019f1931-d683-7528-8674-a3262cc890f0.webp",
    "width": 855,
    "height": 801
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#883277",
  "property_secondary_color": "#0b4351",
  "property_font_color": "#2e2a25",
  "property_color_4": "#b36532",
  "property_color_3": "#883277",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "535 - 1065",
  "property_sqft_min": "535",
  "property_sqft_max": "1065",
  "property_price_range": "847 - 1420.5",
  "property_price_min": "847",
  "property_price_max": "1420.5",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/alonatcastlehills",
  "property_instagram_url": "https://www.instagram.com/alonatcastlehillsapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJufraRWdgXIYR8YMyu0atX8s",
  "property_youtube_url": "https://www.youtube.com/@AlonatCastleHillsApartments",
  "property_yelp_url": "https://www.yelp.com/biz/alon-at-castle-hills-san-antonio",
  "property_tiktok_url": "https://www.tiktok.com/@alonatcastlehills",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Daily upgrades, steps from your door.</strong> Grab coffee in the cyber café, focus in the business center, hit the fitness center, then unwind at the pool, clubhouse, billiards lounge, or movie theater.</p><p>Apartment interiors keep things just as polished with chef-style kitchens, stainless steel appliances, hardwood-style flooring, walk-in closets, and select homes with fireplaces, patios or balconies, garages, and storage.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with everyday polish.</strong> Choose from one- and two-bedroom apartments at Alon at Castle Hills, with select layouts offering a second bath, private patio or balcony, fireplace, or extra patio storage. Inside, details like stainless steel appliances, hardwood-style flooring, washer and dryer connections, and walk-in closets help each home feel thoughtfully finished.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at Alon at Castle Hills.</strong> Preview bright one- and two-bedroom interiors with stainless steel appliances, hardwood-style flooring, walk-in closets, and select fireplaces or outdoor space. Then explore community scenes from the resort-inspired pool, clubhouse, billiards lounge, cyber café, fitness center, and movie theater.</p>",
  "property_home_neighborhood_blurb": "<p><strong>North Central San Antonio, right at your pace.</strong> Alon at Castle Hills places daily errands, dining, and shaded Castle Hills streets close to home, with Alon Town Centre just around the corner. Minutes away, Phil Hardberger Park adds trails, dog parks, the Urban Ecology Center, and the Tobin Land Bridge, while Wurzbach Parkway, Blanco Road, Lockhill Selma Road, and NW Military Highway keep the Medical Center, airport area, and downtown within easy reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents love the cared-for feel.</strong> Reviews point to clean grounds, pet-friendly touches, a parklike setting, and inviting spots like the pretty pool, picnic areas, and package pickup. The team earns praise, too, with attentive office support, approachable management, smooth move-ins, and courteous maintenance. Read more to see how everyday service and community events shape life at Alon at Castle Hills.</p>",
  "property_neighborhood_blurb": "<p><strong>Your North Central San Antonio routine starts close by.</strong> From Alon at Castle Hills, you can move easily between shaded Castle Hills streets, everyday errands at Alon Town Centre, and local dining without turning the day into a long drive. When you want fresh air, Phil Hardberger Park brings trails, dog parks, the Urban Ecology Center, and the Tobin Land Bridge just minutes from home. Wurzbach Parkway, Lockhill Selma Road, Blanco Road, and NW Military Highway keep the wider city within reach, from airport-area offices to the Medical Center and downtown plans. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how this connected San Antonio address fits your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>More than a place to come home to.</strong> At Alon at Castle Hills, your amenity spaces give each day a few easy upgrades: start with coffee in the cyber café, plug in at the business center, fit in a workout, or move from the pool to the clubhouse, billiards lounge, and movie theater without leaving the community.</p><p>Inside your apartment, chef-style kitchens with stainless steel appliances, hardwood-style flooring, walk-in closets, washer/dryer connections, and select-home extras like fireplaces, patios or balconies, garages, and storage help your space work harder. Add gated access, online resident services, LUXER package lockers, and a leash-free dog park, and you have practical comfort built into the routine. See the spaces in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Alon at Castle Hills home?</strong> Choose a one- or two-bedroom apartment with polished finishes like chef’s kitchens, stainless steel appliances, hardwood-style flooring, washer/dryer connections, walk-in closets, and a private patio or balcony. Start your online application today and take the next step.</p>",
  "property_contactus_blurb": "<p><strong>Have a question about Alon at Castle Hills?</strong> Contact our leasing team for help with availability, directions, or next steps. From polished one- and two-bedroom layouts to a convenient North Central San Antonio setting near major routes, we’re here to help you feel ready to visit.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Alon at Castle Hills?</strong> Start here for quick answers about the community, leasing, amenities, and everyday living in North Central San Antonio. If you need more details or want help choosing your next step, the leasing team is happy to assist.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits how you live.</strong> Alon at Castle Hills offers a focused collection of one- and two-bedroom apartments, from efficient one-bath designs to larger two-bedroom homes with the option of a second bath. As you compare availability, look for the everyday details that make each plan feel complete: chef-inspired kitchens with stainless steel appliances, hardwood-style flooring, washer and dryer connections, generous walk-in closets, and private patios or balconies in select homes. Some layouts add extras like a fireplace or patio storage, giving you more ways to settle in and stay organized. Browse current pricing and openings, then use the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to get a closer look at the spaces that catch your eye.</p>",
  "property_gallery_blurb": "<p><strong>See the details before you tour.</strong> Browse the Alon at Castle Hills photo gallery for a closer look at bright one- and two-bedroom apartment interiors, from chef-style kitchens with stainless steel appliances to hardwood-style flooring, walk-in closets, and select homes with fireplaces or private outdoor space. Let the images guide you through the resort-inspired pool, comfortable clubhouse, billiards lounge, cyber café, fitness center, and movie theater—each space captured so you can understand the feel of the community at a glance. When a layout or amenity catches your eye, continue with the <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Alon at Castle Hills in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Alon at Castle Hills on the map.</strong> Browse available one- and two-bedroom apartments, then see how North Central San Antonio connections put shopping, parks, airport-area convenience, and quick routes to the Medical Center, downtown, and beyond within easy reach.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, right where you live.</strong> At Alon at Castle Hills, your cat or dog can be part of the everyday rhythm—from easy-care hard-surface flooring inside your apartment to a leash-free dog park just steps from your door.</p><p>With two pets welcome per home and no weight limit, it’s easy to picture daily life with your companion in tow. Stretch your legs around the community, head out for a longer walk at nearby Phil Hardberger Park’s dog areas, then come back to the comfort of a pet-friendly San Antonio apartment with practical perks for busy days. See more community features on the <a href=\"/amenities\">amenities page</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to explore the spaces in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share the comfort of Alon at Castle Hills.</strong><br>Love the chef’s kitchens, private patios or balconies, resort-style pool, 24-hour fitness center, and easy North Central San Antonio convenience? Invite a friend to discover it all—and start their next chapter right here with you.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Alon at Castle Hills.</strong><br>Use online resident services to pay rent, submit maintenance requests, and manage your account—so everyday details stay as polished and convenient as the North Central San Antonio comfort you come home to.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying.</strong> Reviews for Alon at Castle Hills often highlight a community that feels well cared for, from clean grounds and pet-friendly touches to a “parklike atmospheric complex” with a pretty pool and picnic areas.</p><p>You’ll also find praise for the people behind the experience: attentive office staff, approachable management, smooth move-in support, and maintenance described as helpful and courteous. Residents mention thoughtful communication, fun community events like Bingo and dinner gatherings, plus convenient everyday services such as package pickup and valet trash. Read the reviews below to get a clearer feel for life at Alon at Castle Hills from the people who know it best.</p>",
  "property_created_at": "1752256652252",
  "property_scheduletour_blurb": "<p><strong>See polished comfort up close.</strong> Tour Alon at Castle Hills and picture the details in person—from chef’s kitchens and stainless steel appliances to hardwood-style flooring, walk-in closets, and private patios or balconies. Schedule your visit today and get a feel for the spaces and community features that make everyday living easier.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will be in touch soon. In the meantime, picture polished everyday comfort at Alon at Castle Hills, with one- and two-bedroom layouts, chef’s kitchens, private patios or balconies, and inviting spaces to relax, recharge, and feel at home.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> Explore Alon at Castle Hills through immersive virtual tours that let you move at your own pace, zoom in on finishes, and get a feel for the spaces that shape daily life in San Antonio. Start with the two-bedroom, one-bath apartment tour to see the flow from living area to kitchen and bedrooms, then compare options on the <a href=\"/floor-plans\">floor plans</a> page when you’re ready.</p><p>Continue through the fitness center, leasing office, business center, movie theater, and clubhouse to preview the community experience beyond your front door. Like what you see? View more <a href=\"/amenities\">amenity details</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> for a closer look.</p>",
  "property_copyright": "2025 All Rights Reserved. Alon at Castle Hills",
  "property_seo_title_home": "Alon at Castle Hills | Apartments in San Antonio, TX",
  "property_seo_description_home": "Elevate your living experience at Alon at Castle Hills in San Antonio, TX. With chic one and two-bedroom floor plans, you'll find the perfect fit for your lifestyle. Enjoy top-notch amenities like a state-of-the-art fitness center, refreshing pool, and a dog park for your furry friends. Work or unwind in stylish spaces like our billiards room and theater. Your new home awaits—embrace comfort and convenience today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in San Antonio, TX",
  "property_seo_description_floorplans": "Unlock the door to your ideal living space at Alon at Castle Hills in the heart of San Antonio, TX. With thoughtfully designed one and two-bedroom floor plans, you're just moments away from your next adventure. Browse our available apartment homes and find the perfect layout that suits your lifestyle and aspirations.",
  "property_seo_title_amenities": "Amenities | San Antonio, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Alon at Castle Hills in San Antonio, TX, where exceptional amenities redefine home. From a chef's kitchen and billiards to a state-of-the-art fitness center and dog park, our thoughtfully designed apartments offer the perfect blend of comfort and convenience. Enjoy stunning pool views, walk-in closets, and easy online resident services. Elevate your lifestyle with our premier clubhouse, cyber café, and relaxation spaces. Dive into a community that has it all—your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in San Antonio, TX",
  "property_seo_description_gallery": "Experience the vibrant lifestyle at Alon at Castle Hills in San Antonio, TX. Our diverse floor plans, featuring stylish one and two-bedroom options, cater to your unique living needs. Enjoy resort-style amenities like a refreshing pool, a state-of-the-art fitness center, and a cozy clubhouse with a chef’s kitchen. Picture lazy afternoons in our dog park or entertaining in the theatre room. With online resident services and secure access gates, your comfort and convenience are our top priorities. Join us at Alon at Castle Hills—where every moment feels like home!",
  "property_seo_title_virtualtours": "Virtual Tours | Alon at Castle Hills Apartments",
  "property_seo_description_virtualtours": "Step inside Alon at Castle Hills in San Antonio, TX, where modern living meets exceptional style! Our stunning one and two-bedroom floor plans offer the perfect blend of comfort and convenience. Experience the charm of our vibrant community through a captivating virtual tour today—your dream apartment awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Alon at Castle Hills Apartments",
  "property_seo_description_interactivemap": "\"Experience modern living at Alon at Castle Hills in vibrant San Antonio, TX. Choose from stylish one and two-bedroom floor plans and indulge in exceptional amenities like a luxurious pool, vibrant clubhouse, and a dog park for your furry friends. Our interactive community map makes finding your perfect apartment easy—view pricing, explore layouts, and secure your new home today!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in San Antonio, TX",
  "property_seo_description_neighborhood": "Experience the charm of San Antonio at Alon at Castle Hills! Nestled in a vibrant neighborhood, our community offers easy access to local favorites, dining delights, and stunning parks. Uncover a lifestyle enriched by culture and convenience as you step outside. Dive into the local scene and see what adventures await just around the corner!",
  "property_seo_title_contact": "Contact Us | Alon at Castle Hills",
  "property_seo_description_contact": "Looking for your dream apartment in San Antonio? At Alon at Castle Hills, we offer stylish one and two-bedroom floor plans tailored to your lifestyle. Have questions? Our friendly leasing team is here to help – reach out today and find your perfect home!",
  "property_seo_title_faqs": "FAQs | Apartments in San Antonio, TX",
  "property_seo_description_faqs": "Uncover a world of convenience and luxury at Alon at Castle Hills in San Antonio, TX. With thoughtfully designed floor plans—one and two-bedroom apartments—life here is tailored for every lifestyle. Dive into top-tier amenities like our refreshing pool, state-of-the-art fitness center, and inviting clubhouse. Have questions? Browse our FAQs for answers about our community's unique offerings, including LUXER Package Lockers, pet-friendly spaces, and modern conveniences that redefine apartment living. Your perfect home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in San Antonio, TX",
  "property_seo_description_reviews": "\"Discover why residents love calling Alon at Castle Hills home! With spacious one and two-bedroom floor plans and a host of amenities, including a lavish pool, modern fitness center, and vibrant clubhouse, there's something for everyone. From stylish chef's kitchens to an inviting dog park and convenient online services, comfort and convenience await in San Antonio, TX. Check out what our residents have to say and envision your new life today!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in San Antonio, TX",
  "property_seo_description_applynow": "Welcome to Alon at Castle Hills in San Antonio, TX—your gateway to stylish living. Choose from one or two-bedroom floor plans designed with you in mind, featuring modern kitchens, walk-in closets, and elegant finishes. Enjoy unparalleled amenities including a sparkling pool, fitness center, and a vibrant clubhouse, all with the added convenience of online resident services. With a dog park, theatre room, and secure access gates, your new home offers both comfort and community. Why wait? Secure your spot and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Alon at Castle Hills",
  "property_seo_description_residentaccess": "\"Manage your Alon at Castle Hills experience effortlessly! Log in to our resident portal to pay rent, schedule maintenance, and access exclusive community updates in beautiful San Antonio, TX.\"",
  "property_seo_title_referafriend": "Refer A Friend | Alon at Castle Hills",
  "property_seo_description_referafriend": "\"Great friends make great neighbors! Share the Alon at Castle Hills experience with your circle and help them find their perfect home in the heart of San Antonio. Refer a friend today and watch your community thrive!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Alon at Castle Hills",
  "property_seo_description_scheduletour": "\"Step into the vibrant lifestyle at Alon at Castle Hills in San Antonio, TX. Immerse yourself in our stunning apartments and resort-style amenities. Ready to experience it for yourself? Schedule a tour of our community today!\"",
  "property_seo_title_privacy": "Privacy Policy | Alon at Castle Hills",
  "property_seo_description_privacy": "At Alon at Castle Hills, we value your trust. Dive into our privacy policy to learn how we protect your personal information and ensure a secure living experience in the heart of San Antonio, TX. Your privacy matters—get the details you need today!",
  "property_seo_title_accessibility": "Website Accessibility | Alon at Castle Hills",
  "property_seo_description_accessibility": "At Alon at Castle Hills in San Antonio, TX, we’re committed to ensuring everyone can enjoy our vibrant community. Our Accessibility Statement highlights our dedication to digital inclusion and making every resident feel at home. Join us in building a welcoming environment where all can thrive!",
  "property_seo_title_sitemap": "Sitemap | Alon at Castle Hills",
  "property_seo_description_sitemap": "\"Navigate your way to the perfect home at Alon at Castle Hills in San Antonio, TX. Our sitemap offers a clear path to explore our vibrant community and detailed amenities tailored just for you. Your ideal living experience awaits—uncover it today!\"",
  "property_seo_title_thankyou": "Thank You | Alon at Castle Hills",
  "property_seo_description_thankyou": "Thank you for reaching out to Alon at Castle Hills, San Antonio's premier apartment community. Your inquiry is important to us, and you’ll soon be hearing from our team to help you find your perfect home in a vibrant, welcoming environment. Stay tuned for exciting updates and opportunities!",
  "property_seo_title_pets": "Pet Policy | Apartments in Summerville, SC\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319341",
  "amenities": [
    {
      "id": "custom_89c4dcec-ae3a-44d8-b74a-aa0fb4dfacca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Luxor Resident Package System",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_246ec3d1-7539-4953-8e07-3c079072bac9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Gated Community",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ca741145-16eb-4149-a898-c8fe29ac3151",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2a6ae44e-c662-4196-9c4f-54ee24822cca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000602",
      "title": "Billiards",
      "amount": "0.0000",
      "description": "Billiards and TV Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_179cbe63-36cf-4ec4-9769-7d866083c0b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000607",
      "title": "Business Center",
      "amount": "0.0000",
      "description": "Professional Business Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5b92984f-d743-4dcb-899c-b618aa0c69b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000613",
      "title": "Chef`s Kitchen",
      "amount": "0.0000",
      "description": "Modern, Chefs Kitchen",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a9d0ac87-4303-4c2c-b988-f92c02a8f6ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000614",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Resident Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_20780d1f-00da-4765-8af0-1d32240f84ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5e118501-ea25-4e2a-b17d-f056921520a3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000633",
      "title": "Fire",
      "amount": "0.0000",
      "description": "Fireplace*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_64e84b3c-ee3e-410e-b0b9-3a51688903ee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af7d1296-2301-4b5b-a378-34d03f3fc218",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Attached Garages Available",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7a13e2b8-12d0-4f4e-9942-8720da686a9a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Hardwood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_24ff7086-8615-4be9-8f74-37a9a288c247",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3f8cb9fa-2da8-4d65-8a38-4e6ddbcdc59c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7e446c03-c7b2-4abc-bf7c-a23d66f92a76",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patio or Balcony",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9e531639-13ed-4ada-8e7b-8923fe5d8f30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Swimming Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_db130f77-ec7a-47da-8ff9-51ac1bd7ed0a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_14275c75-4d25-40fe-99e5-f74adb71536a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000687",
      "title": "Storage Spaces",
      "amount": "0.0000",
      "description": "Patio Storage*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_56594a10-83c5-4154-a782-771059217dc1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000693",
      "title": "Theatre Room",
      "amount": "0.0000",
      "description": "Movie Theater",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_73b16a69-ce36-4f47-be70-b5eef833f5dc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000703",
      "title": "W&D Connections",
      "amount": "0.0000",
      "description": "Full Size Washer & Dryer Connections",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_afb6afb2-3bf9-461d-8f7f-9018116739bd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c322c770-bd6e-4d94-8616-a72ffc02040a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "external_id": "P000002384",
      "title": "Cyber Cafe",
      "amount": "0.0000",
      "description": "Cyber Cafe with Coffee Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_78e86e7f-3b49-4e26-bdb5-33da0718667f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019e897d-40cd-73a3-bcf1-5d639ee32b09.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, orange headboard, and a balcony view.",
        "public_id": "019e897d-40cd-73a3-bcf1-5d639ee32b09",
        "storage_key": "property/5735011386916864/019e897d-40cd-73a3-bcf1-5d639ee32b09.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a plush queen-size bed with an orange tufted headboard, accented by decorative pillows. Enjoy natural light and private balcony access.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, orange headboard, and a balcony view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_649e3285-e166-471d-8fae-dabd8b9dcf12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019e897d-3e2a-737c-83bc-5a9a819ebcc2.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a single vanity, toilet, and bathtub with a gray and white striped shower curtain.",
        "public_id": "019e897d-3e2a-737c-83bc-5a9a819ebcc2",
        "storage_key": "property/5735011386916864/019e897d-3e2a-737c-83bc-5a9a819ebcc2.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Step into this modern bathroom featuring a spacious vanity with ample counter space, a large mirror, and a bathtub with a stylish shower curtain. Enjoy the clean and functional design.",
      "link": "",
      "alt_text": "Modern bathroom with a single vanity, toilet, and bathtub with a gray and white striped shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7b6f42bb-21fe-45e9-b189-aa9af273c24a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019e897d-3f98-7312-a42a-b9e93358fd72.webp",
      "image_media": {
        "alt_text": "Pool table in common area",
        "public_id": "019e897d-3f98-7312-a42a-b9e93358fd72",
        "storage_key": "property/5735011386916864/019e897d-3f98-7312-a42a-b9e93358fd72.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a game of pool in the resident's lounge.",
      "link": "",
      "alt_text": "Pool table in common area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b5cdc63e-34b9-448f-b48d-16e4f83d41ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019e897d-311d-70ef-91c7-bc547a65c5b4.webp",
      "image_media": {
        "alt_text": "Outdoor dog park with agility equipment, benches, and picnic tables.",
        "public_id": "019e897d-311d-70ef-91c7-bc547a65c5b4",
        "storage_key": "property/5735011386916864/019e897d-311d-70ef-91c7-bc547a65c5b4.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy our dedicated outdoor dog park, complete with agility equipment for your furry friends, comfortable benches for relaxation, and picnic tables for social gatherings.",
      "link": "",
      "alt_text": "Outdoor dog park with agility equipment, benches, and picnic tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5624abf4-1c8a-4852-bb37-2fa1285c77f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019e897d-30ff-7009-a43d-9db0525b049a.webp",
      "image_media": {
        "alt_text": "Living room with blue walls, a mounted TV, decorative shelves, a coffee table, and seating.",
        "public_id": "019e897d-30ff-7009-a43d-9db0525b049a",
        "storage_key": "property/5735011386916864/019e897d-30ff-7009-a43d-9db0525b049a.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A spacious and inviting living room featuring vibrant blue walls, a large mounted television, elegant decorative shelves, and a stylish coffee table. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with blue walls, a mounted TV, decorative shelves, a coffee table, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e5fe699c-d0aa-4c3d-9cb8-f81718256c4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019e897d-2e4f-7771-9312-2ec503ca8b62.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e897d-2e4f-7771-9312-2ec503ca8b62",
        "storage_key": "property/5735011386916864/019e897d-2e4f-7771-9312-2ec503ca8b62.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by comfortable lounge chairs and vibrant umbrellas. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8234797f-772c-485f-9705-87b3aa26adb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019e897d-311e-72ae-9176-9cd9426e38be.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, blue accent wall, and large window.",
        "public_id": "019e897d-311e-72ae-9176-9cd9426e38be",
        "storage_key": "property/5735011386916864/019e897d-311e-72ae-9176-9cd9426e38be.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom featuring a king-sized bed, elegant blue accent wall, and ample natural light from the large window.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed, blue accent wall, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a6ee0f29-95f2-4c73-9585-a7240cc24bdf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019e897d-2dea-7046-a680-935bda6b2c08.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, TV, and kitchen area.",
        "public_id": "019e897d-2dea-7046-a680-935bda6b2c08",
        "storage_key": "property/5735011386916864/019e897d-2dea-7046-a680-935bda6b2c08.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, a wooden coffee table, a wall-mounted TV, and an open view to the kitchen and dining area.",
      "link": "",
      "alt_text": "Living room with sofa, coffee table, TV, and kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cb7c6070-21b9-4b7b-bf6b-613ad9870b16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019e897d-2f64-715f-bfe4-12a7c0116d38.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with fountains and lounge chairs.",
        "public_id": "019e897d-2f64-715f-bfe4-12a7c0116d38",
        "storage_key": "property/5735011386916864/019e897d-2f64-715f-bfe4-12a7c0116d38.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax by our stunning resort-style swimming pool, featuring relaxing fountains and plenty of lounge chairs for sunbathing.",
      "link": "",
      "alt_text": "Resort-style swimming pool with fountains and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1c65a118-d3b4-4223-94da-4963ed1965c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019e897d-2f6b-72e8-a64d-858975448c85.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and white cabinetry.",
        "public_id": "019e897d-2f6b-72e8-a64d-858975448c85",
        "storage_key": "property/5735011386916864/019e897d-2f6b-72e8-a64d-858975448c85.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Discover our stylish and functional kitchens, featuring granite countertops, stainless steel appliances, and ample cabinet space for all your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and white cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_56e1e5f9-f389-4b5c-a6d6-ba49ffd0fa16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019e897d-2c5b-713c-88fb-77379e837ee2.webp",
      "image_media": {
        "alt_text": "Coffee bar and dining table in apartment community lounge",
        "public_id": "019e897d-2c5b-713c-88fb-77379e837ee2",
        "storage_key": "property/5735011386916864/019e897d-2c5b-713c-88fb-77379e837ee2.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and a comfortable seating area in the community lounge, perfect for work or relaxation.",
      "link": "",
      "alt_text": "Coffee bar and dining table in apartment community lounge",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9ecda30c-a1d7-43c4-8d77-8946a1356a8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019e897d-2d84-72c1-a61a-f745149eb4d5.webp",
      "image_media": {
        "alt_text": "Two chairs flanking a side table with a lamp.",
        "public_id": "019e897d-2d84-72c1-a61a-f745149eb4d5",
        "storage_key": "property/5735011386916864/019e897d-2d84-72c1-a61a-f745149eb4d5.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A cozy seating area with two plush chairs, a side table, and decorative plants, perfect for relaxing.",
      "link": "",
      "alt_text": "Two chairs flanking a side table with a lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7eb409f1-4e1e-4bc3-be2e-ba93d8f58ea9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019e897d-2d18-71db-861e-84bf8d69703a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with a fountain and lounge chairs",
        "public_id": "019e897d-2d18-71db-861e-84bf8d69703a",
        "storage_key": "property/5735011386916864/019e897d-2d18-71db-861e-84bf8d69703a.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with a relaxing fountain and comfortable lounge chairs. Perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with a fountain and lounge chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_6ed3db0e918e33461a8745d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "The Lodge Restaurant of Castle Hills",
      "poi_type": "Restaurants",
      "poi_address": "1746 Lockhill Selma Rd, San Antonio, TX 78213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3024873065554276093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-lodge-restaurant-of-castle-hills",
      "poi_latitude": "29.53576219999999",
      "poi_longitude": "-98.5221943",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bm6KWdgXIYR_W4C0waC-ik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "ec_1b6b22e61130853f12d9770e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Bee's Mexican Restaurant & Bakery",
      "poi_type": "Restaurants",
      "poi_address": "808 Lockhill Selma Rd, San Antonio, TX 78213, USA",
      "poi_short_description": "Basic eatery offering a variety of classic Mexican chow in a low-key environment.",
      "poi_long_description": "Basic eatery offering a variety of classic Mexican chow in a low-key environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-c52c-737d-9d30-81c3ba21464c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-c52c-737d-9d30-81c3ba21464c",
        "storage_key": "property/5735011386916864/019f1515-c52c-737d-9d30-81c3ba21464c.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9724356048906858440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bees-mexican-restaurant--bakery",
      "poi_latitude": "29.523459",
      "poi_longitude": "-98.505964",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-342-1886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0a2-7169-b5cb-108ae79d6997",
        "storage_key": "property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ82pRtAxgXIYRyK-D_E3a84Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_6f9274150efb464086085469",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Santos Cafe #1",
      "poi_type": "Restaurants",
      "poi_address": "1005 Jackson Keller Rd, Castle Hills, TX 78213, USA",
      "poi_short_description": "Cozy, family-friendly restaurant serving traditional Mexican fare such as enchiladas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-c201-70b3-8e3f-67a10ecd70b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-c201-70b3-8e3f-67a10ecd70b8",
        "storage_key": "property/5735011386916864/019f1515-c201-70b3-8e3f-67a10ecd70b8.webp",
        "width": 1080,
        "height": 507
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1656624362815577305&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santos-cafe-1",
      "poi_latitude": "29.5034483",
      "poi_longitude": "-98.5079443",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-348-9899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0a2-7169-b5cb-108ae79d6997",
        "storage_key": "property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX9r2wcJfXIYR2VzhrxSD_RY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_1b9366673a963fa501df7da3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Bilia Eatery",
      "poi_type": "Restaurants",
      "poi_address": "1900 NW Military Hwy, Castle Hills, TX 78213, USA",
      "poi_short_description": "Quaint cafe offering light lunches and coffee, plus traditional Latin eats such as arepas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-ca21-7740-a4dd-defe46f4d9ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-ca21-7740-a4dd-defe46f4d9ed",
        "storage_key": "property/5735011386916864/019f1515-ca21-7740-a4dd-defe46f4d9ed.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://eatbilia.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=10947760297989284147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bilia-eatery",
      "poi_latitude": "29.5281555",
      "poi_longitude": "-98.5197469",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-530-1333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0a2-7169-b5cb-108ae79d6997",
        "storage_key": "property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ49XK0W1hXIYRM6HGv_xB7pc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cuban_restaurant"
    },
    {
      "id": "ec_0a6e89788388dd396ce0bcd0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Clementine",
      "poi_type": "Restaurants",
      "poi_address": "2195 NW Military Hwy, San Antonio, TX 78213, USA",
      "poi_short_description": "Globally-inspired, seasonal menu served in a bright, stylish interior decorated with food art.",
      "poi_long_description": "Globally-inspired, seasonal menu served in a bright, stylish interior decorated with food art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-d96b-715f-8672-6df2e148155a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-d96b-715f-8672-6df2e148155a",
        "storage_key": "property/5735011386916864/019f1515-d96b-715f-8672-6df2e148155a.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.clementine-sa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9128480215974477382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clementine",
      "poi_latitude": "29.5329986",
      "poi_longitude": "-98.521877",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-503-5121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0a2-7169-b5cb-108ae79d6997",
        "storage_key": "property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhTgapmZgXIYRRv5WRGTgrn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_07e13c1f0f424e0c99e8887a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Flying Tiger Thai Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2114 NW Military Hwy, Castle Hills, TX 78213, USA",
      "poi_short_description": "Casual, BYOB, family-owned Thai eatery dishes from familiar curries, noodles and fried rice to pot stickers, along with vegan options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-ce06-730c-973f-aa7229f73f59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-ce06-730c-973f-aa7229f73f59",
        "storage_key": "property/5735011386916864/019f1515-ce06-730c-973f-aa7229f73f59.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.flyingtigerthairestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16297696998714955914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flying-tiger-thai-restaurant",
      "poi_latitude": "29.5315278",
      "poi_longitude": "-98.522065",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-281-5521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0a2-7169-b5cb-108ae79d6997",
        "storage_key": "property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxu-illhXIYRithaSRINLeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "ec_b3b1239042fc9e9a59ea0b08",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "European Dumplings Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2211 NW Military Hwy Ste 131b, Castle Hills, TX 78213, USA",
      "poi_short_description": "Casual Ukrainian eatery offering comfort food, from borscht to pierogi, in the Castle Hills Market.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-d0c9-7177-88b7-65234fe786f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-d0c9-7177-88b7-65234fe786f8",
        "storage_key": "property/5735011386916864/019f1515-d0c9-7177-88b7-65234fe786f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://europeandumplings.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3279906893001183077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "european-dumplings-cafe",
      "poi_latitude": "29.5348406",
      "poi_longitude": "-98.5235141",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 726-219-2483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0a2-7169-b5cb-108ae79d6997",
        "storage_key": "property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZap0WcFDXIYRZc-wBfGRhC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ukrainian_restaurant"
    },
    {
      "id": "ec_cd086af59a325284cee05b7f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Sushishima Japanese Restaurant (Castle Hills)",
      "poi_type": "Restaurants",
      "poi_address": "2211 NW Military Hwy Ste 132, Castle Hills, TX 78213, USA",
      "poi_short_description": "Casual eatery serving sushi, as well as Japanese dinners and barbecued dishes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-ce6d-714d-a020-94cd2c084292.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-ce6d-714d-a020-94cd2c084292",
        "storage_key": "property/5735011386916864/019f1515-ce6d-714d-a020-94cd2c084292.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://sushishima.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17572957617202497827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushishima-japanese-restaurant-castle-hills",
      "poi_latitude": "29.5348019",
      "poi_longitude": "-98.5236133",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-888-0363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0a2-7169-b5cb-108ae79d6997",
        "storage_key": "property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJt3ym4-xhXIYRI4lZ6tiv3_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_6397edeb80172163a312a6fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Los Azulejos Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2267 NW Military Hwy #101, San Antonio, TX 78213, USA",
      "poi_short_description": "Relaxed Mexican restaurant with decorative tilework doling out tacos, enchiladas & more, plus a bar.",
      "poi_long_description": "Relaxed Mexican restaurant with decorative tilework doling out tacos, enchiladas & more, plus a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-c527-7739-98f6-14b44d64436b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-c527-7739-98f6-14b44d64436b",
        "storage_key": "property/5735011386916864/019f1515-c527-7739-98f6-14b44d64436b.webp",
        "width": 1280,
        "height": 918
      },
      "poi_business_url": "http://www.losazulejosrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12319473900104727076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-azulejos-restaurant",
      "poi_latitude": "29.5373902",
      "poi_longitude": "-98.5256089",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-281-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0a2-7169-b5cb-108ae79d6997",
        "storage_key": "property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4ffNyNhXIYRJDpwoz2Q96o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_732d15ff4354942e2324de8b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Sushihana Japanese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1810 NW Military Hwy, San Antonio, TX 78213, USA",
      "poi_short_description": "Contemporary spot offering an array of sushi & Asian fusion dishes in a serene setting with a patio.",
      "poi_long_description": "Contemporary spot offering an array of sushi & Asian fusion dishes in a serene setting with a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-c266-779f-bb15-1d5735278756.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-c266-779f-bb15-1d5735278756",
        "storage_key": "property/5735011386916864/019f1515-c266-779f-bb15-1d5735278756.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.sushihanasan.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1385263485344514833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushihana-japanese-restaurant",
      "poi_latitude": "29.527544",
      "poi_longitude": "-98.5193413",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-340-7808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0a2-7169-b5cb-108ae79d6997",
        "storage_key": "property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJC5GHLmVgXIYREYNH7MxxORM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_254be6275df081e1ac6b0a34",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Las Palapas - Castle Hills",
      "poi_type": "Restaurants",
      "poi_address": "6007 West Ave, Castle Hills, TX 78213, USA",
      "poi_short_description": "Local chain offering Mexican & Tex-Mex fare in a casual setup with a drive-thru.",
      "poi_long_description": "Local chain offering Mexican & Tex-Mex fare in a casual setup with a drive-thru.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-d4aa-71d9-a9ba-af193e0ce36b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-d4aa-71d9-a9ba-af193e0ce36b",
        "storage_key": "property/5735011386916864/019f1515-d4aa-71d9-a9ba-af193e0ce36b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://laspalapas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8643049717241282283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "las-palapas---castle-hills",
      "poi_latitude": "29.5163205",
      "poi_longitude": "-98.5263405",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-437-0361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0a2-7169-b5cb-108ae79d6997",
        "storage_key": "property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzcT5v39gXIYR6_40zOxH8nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_49c88a44de2749780840b510",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Dough Pizzeria Napoletana",
      "poi_type": "Restaurants",
      "poi_address": "6989 Blanco Rd, San Antonio, TX 78216, USA",
      "poi_short_description": "Buzzy eatery with authentic Neapolitan pizzas, salads, housemade burrata & an all-Italian wine list.",
      "poi_long_description": "Buzzy eatery with authentic Neapolitan pizzas, salads, housemade burrata & an all-Italian wine list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-d3f6-75ec-b1ab-d849c9af302c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-d3f6-75ec-b1ab-d849c9af302c",
        "storage_key": "property/5735011386916864/019f1515-d3f6-75ec-b1ab-d849c9af302c.webp",
        "width": 1280,
        "height": 729
      },
      "poi_business_url": "http://www.doughpizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2771677637699254834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dough-pizzeria-napoletana",
      "poi_latitude": "29.5192853",
      "poi_longitude": "-98.507452",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-979-6565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0a2-7169-b5cb-108ae79d6997",
        "storage_key": "property/5735011386916864/019f1513-c0a2-7169-b5cb-108ae79d6997.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeZeMKHVgXIYRMjr1YiD6diY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_ae2ea7269399c681ba97d6fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "11551 West Ave, San Antonio, TX 78213, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-d06b-7395-9077-2e1e6743a5cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-d06b-7395-9077-2e1e6743a5cd",
        "storage_key": "property/5735011386916864/019f1515-d06b-7395-9077-2e1e6743a5cd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/san-antonio/blanco-and-west-ave-h-e-b-195?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=17951059510067973591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.546987",
      "poi_longitude": "-98.510848",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-340-7976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0c3-74e9-ae93-53e8dd8835e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0c3-74e9-ae93-53e8dd8835e4",
        "storage_key": "property/5735011386916864/019f1513-c0c3-74e9-ae93-53e8dd8835e4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw-L5zkZgXIYR181__4P5Hvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_9aae88f53051336c5b819e48",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "8503 NW Military Hwy, San Antonio, TX 78231, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-d640-76d5-b448-86b7e64cc82b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-d640-76d5-b448-86b7e64cc82b",
        "storage_key": "property/5735011386916864/019f1515-d640-76d5-b448-86b7e64cc82b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/tx/san-antonio/alon-market-h-e-b-102?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=586250807360616769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.552819",
      "poi_longitude": "-98.534243",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-479-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0c3-74e9-ae93-53e8dd8835e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0c3-74e9-ae93-53e8dd8835e4",
        "storage_key": "property/5735011386916864/019f1513-c0c3-74e9-ae93-53e8dd8835e4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJafb0jftgXIYRQfkD0gDIIgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_714804a6d5b741d4c96b22b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "6915 West Ave, Castle Hills, TX 78213, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-dcdd-73a8-b741-d379ce433327.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-dcdd-73a8-b741-d379ce433327",
        "storage_key": "property/5735011386916864/019f1515-dcdd-73a8-b741-d379ce433327.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/castle-hills-tx-pharmacies/6915-w-ave-castle-hills-tx-78213/storeid=7306?WT.mc_id=LS_GOOGLE_FS_7306",
      "poi_directions_map_url": "https://maps.google.com/?cid=15896696319467705805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "29.5328276",
      "poi_longitude": "-98.5234838",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-341-1487",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU5TA_WNgXIYRzdUhCBRpnNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_6e335a9ccd7dddc4af4d2312",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "10411 West Ave, San Antonio, TX 78213, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-dd04-7216-9c1b-d13af6cca829.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-dd04-7216-9c1b-d13af6cca829",
        "storage_key": "property/5735011386916864/019f1515-dd04-7216-9c1b-d13af6cca829.webp",
        "width": 1280,
        "height": 870
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-10411+west+ave-san+antonio-tx-78213/id=4374",
      "poi_directions_map_url": "https://maps.google.com/?cid=15190032250742520052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.535844",
      "poi_longitude": "-98.5206179",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-979-6575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVFG_2ZgXIYR9Dg8ENrVzdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_7d75a3b99989eeb06867d3b2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "12639 Blanco Rd, San Antonio, TX 78216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-e39a-765d-b88a-0102172804cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-e39a-765d-b88a-0102172804cf",
        "storage_key": "property/5735011386916864/019f1515-e39a-765d-b88a-0102172804cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/4162-san-antonio-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3112489727931642472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "29.555813",
      "poi_longitude": "-98.5186853",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-591-6282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c169-70dd-943b-0472913bac5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c169-70dd-943b-0472913bac5e",
        "storage_key": "property/5735011386916864/019f1513-c169-70dd-943b-0472913bac5e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQwO79VFgXIYRaPJquOrIMSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_531c58a9dcc626aa2cb92dd3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Lockhill Village Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "2323-2251 Lockhill Selma Rd, San Antonio, TX 78230, USA",
      "poi_short_description": "Shopping mall featuring a variety of stores, a gym, and a Mexican restaurant.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-e01a-75b5-a3c5-13dafd4695fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-e01a-75b5-a3c5-13dafd4695fb",
        "storage_key": "property/5735011386916864/019f1515-e01a-75b5-a3c5-13dafd4695fb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4822478148054903726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lockhill-village-shopping-center",
      "poi_latitude": "29.543036",
      "poi_longitude": "-98.529465",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-593-0777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c169-70dd-943b-0472913bac5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c169-70dd-943b-0472913bac5e",
        "storage_key": "property/5735011386916864/019f1513-c169-70dd-943b-0472913bac5e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_cZj6PVgXIYRrmvlN1Pi7EI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_0238dccdc104ab28501d68a0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Castle Oaks Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "8055 West Ave #100, Castle Hills, TX 78213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.caissonre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6852232379450178012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "castle-oaks-village",
      "poi_latitude": "29.5348322",
      "poi_longitude": "-98.521684",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-934-7368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c169-70dd-943b-0472913bac5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c169-70dd-943b-0472913bac5e",
        "storage_key": "property/5735011386916864/019f1513-c169-70dd-943b-0472913bac5e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoTNtAA1hXIYR3LmOXwsFGF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_bb47367801f8d069b4278855",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "12702 NW Military Hwy, San Antonio, TX 78231, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-e029-77bd-8c07-9f330a0b9e80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-e029-77bd-8c07-9f330a0b9e80",
        "storage_key": "property/5735011386916864/019f1515-e029-77bd-8c07-9f330a0b9e80.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/san-antonio/12702-nw-military-hwy-36526?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5052542611752386905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "29.5585663",
      "poi_longitude": "-98.5347036",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-408-1356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-3ea4-73ee-adf8-cfec0d2c051c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1516-3ea4-73ee-adf8-cfec0d2c051c",
        "storage_key": "property/5735011386916864/019f1516-3ea4-73ee-adf8-cfec0d2c051c.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJL38vxv1gXIYRWYEGYrw8HkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_7216d1ce54a4dde376c7f80d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "AutoZone Auto Parts",
      "poi_type": "Shopping & Retail",
      "poi_address": "2315 Lockhill Selma Rd, San Antonio, TX 78230, USA",
      "poi_short_description": "Chain retailer for car parts such as new and remanufactured hard parts, plus accessories and tools.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-e019-76ab-b581-23cca260c6bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-e019-76ab-b581-23cca260c6bd",
        "storage_key": "property/5735011386916864/019f1515-e019-76ab-b581-23cca260c6bd.webp",
        "width": 700,
        "height": 466
      },
      "poi_business_url": "https://www.autozone.com/locations/tx/san-antonio/2315-lockhill-selma-rd.html?cmpid=LOC:US:EN:AD:NL:1000000:GEN:3130",
      "poi_directions_map_url": "https://maps.google.com/?cid=5670995724744641683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "autozone-auto-parts",
      "poi_latitude": "29.5436391",
      "poi_longitude": "-98.5296495",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-541-8861",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c169-70dd-943b-0472913bac5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c169-70dd-943b-0472913bac5e",
        "storage_key": "property/5735011386916864/019f1513-c169-70dd-943b-0472913bac5e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbZhfwPVgXIYRk8wpwJBss04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "auto_parts_store"
    },
    {
      "id": "ec_bc8ecf5d9b334e80160b7675",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Castle Hills Elementary School",
      "poi_type": "Education",
      "poi_address": "200 Lemonwood Dr, San Antonio, TX 78213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-e143-7668-9d1f-ca42de03b53c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-e143-7668-9d1f-ca42de03b53c",
        "storage_key": "property/5735011386916864/019f1515-e143-7668-9d1f-ca42de03b53c.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://castlehills.neisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11971976616208998034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "castle-hills-elementary-school",
      "poi_latitude": "29.5211057",
      "poi_longitude": "-98.5196692",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-407-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGQK7o3lgXIYRkp5rXE0BJaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_a6a37bf20e45a25106a981ee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Larkspur Elementary School",
      "poi_type": "Education",
      "poi_address": "1802 Larkspur Dr, San Antonio, TX 78213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-e1f3-75be-ae8d-062a90276a20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-e1f3-75be-ae8d-062a90276a20",
        "storage_key": "property/5735011386916864/019f1515-e1f3-75be-ae8d-062a90276a20.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "http://larkspur.neisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=634709521138161682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "larkspur-elementary-school",
      "poi_latitude": "29.5432012",
      "poi_longitude": "-98.5223711",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-407-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp6JOF1xgXIYREpj_VvLwzgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_5fb12e6d24b30ae62f944938",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Jackson Middle School",
      "poi_type": "Education",
      "poi_address": "4538 Vance Jackson Rd, San Antonio, TX 78230, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-e8ad-714f-9653-56197c9747f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-e8ad-714f-9653-56197c9747f3",
        "storage_key": "property/5735011386916864/019f1515-e8ad-714f-9653-56197c9747f3.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://jackson.neisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12833318003168462656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jackson-middle-school",
      "poi_latitude": "29.5169391",
      "poi_longitude": "-98.5346832",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-356-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ26tCiIFgXIYRQEd75LoaGbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_e7717f8098c64da1ffcca32a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Legacy of Educational Excellence (LEE) High School",
      "poi_type": "Education",
      "poi_address": "1400 Jackson Keller Rd, San Antonio, TX 78213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-ec9c-70da-a088-5616e2104d1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-ec9c-70da-a088-5616e2104d1b",
        "storage_key": "property/5735011386916864/019f1515-ec9c-70da-a088-5616e2104d1b.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://lee.neisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1265560729870975393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legacy-of-educational-excellence-lee-high-school",
      "poi_latitude": "29.5075199",
      "poi_longitude": "-98.5159549",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-356-0800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGSKa8NpfXIYRocGkUccskBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_95b6f90f078c018fe88c62d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "BASIS San Antonio - Shavano Campus",
      "poi_type": "Education",
      "poi_address": "4114 Lockhill Selma Rd, San Antonio, TX 78230, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-0161-768d-b5db-b6cb87e34034.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-0161-768d-b5db-b6cb87e34034",
        "storage_key": "property/5735011386916864/019f1516-0161-768d-b5db-b6cb87e34034.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://enrollbasis.com/texas/san-antonio-shavano/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=12898711711338319390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "basis-san-antonio---shavano-campus",
      "poi_latitude": "29.571798",
      "poi_longitude": "-98.5643293",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-874-9250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy-seM2BgXIYRHs59DvZtAbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_c94d92f9618cd504fc65bb4e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "The Christian School at Castle Hills",
      "poi_type": "Education",
      "poi_address": "2216 NW Military Hwy, Castle Hills, TX 78213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-ec27-74b8-9e77-dfc8bafa6704.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-ec27-74b8-9e77-dfc8bafa6704",
        "storage_key": "property/5735011386916864/019f1515-ec27-74b8-9e77-dfc8bafa6704.webp",
        "width": 1056,
        "height": 594
      },
      "poi_business_url": "https://castlehills.school/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1157343735735074812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-christian-school-at-castle-hills",
      "poi_latitude": "29.5336852",
      "poi_longitude": "-98.5244654",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-878-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx_QB92BgXIYR_D-D6_61DxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_409dc8e42f8192e47559d5a8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Antonian College Preparatory High School",
      "poi_type": "Education",
      "poi_address": "6425 West Ave, San Antonio, TX 78213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-f8fd-7318-b173-fe43cc35326e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-f8fd-7318-b173-fe43cc35326e",
        "storage_key": "property/5735011386916864/019f1515-f8fd-7318-b173-fe43cc35326e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.antonian.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16834569968898609903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "antonian-college-preparatory-high-school",
      "poi_latitude": "29.5224028",
      "poi_longitude": "-98.5268717",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-344-9265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJbOwjH1gXIYR7xKpfjFooOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_2d177e8df8e74c9dae21bc76",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "St. Gregory the Great Catholic School",
      "poi_type": "Education",
      "poi_address": "700 Dewhurst Rd, San Antonio, TX 78213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-f216-73a8-8f22-1a27db5375df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-f216-73a8-8f22-1a27db5375df",
        "storage_key": "property/5735011386916864/019f1515-f216-73a8-8f22-1a27db5375df.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.stgregorysa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16380764289811476044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-gregory-the-great-catholic-school",
      "poi_latitude": "29.4989386",
      "poi_longitude": "-98.5446494",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-342-0281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs_ID-jteXIYRTO6dI1UqVOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_94de5696ef5d8028151ec210",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Northwest Vista College",
      "poi_type": "Education",
      "poi_address": "3535 N Ellison Dr, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-eedc-7772-9d6a-4357c42faf12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-eedc-7772-9d6a-4357c42faf12",
        "storage_key": "property/5735011386916864/019f1515-eedc-7772-9d6a-4357c42faf12.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.alamo.edu/nvc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17417931226689792052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-vista-college",
      "poi_latitude": "29.4716439",
      "poi_longitude": "-98.705443",
      "poi_miles_from_property": "15.6 mi",
      "poi_walking_minutes": "5 hours 52 mins",
      "poi_biking_minutes": "1 hour 34 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 210-486-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO8IBBVpCXIYRNGgHoSrsuPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_fc27cac25b6381876670f48e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "I'm Just A Kid",
      "poi_type": "Education",
      "poi_address": "5038 West Ave, San Antonio, TX 78213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-f40f-740f-acd8-d496dc3201a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-f40f-740f-acd8-d496dc3201a0",
        "storage_key": "property/5735011386916864/019f1515-f40f-740f-acd8-d496dc3201a0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://imjustakid.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7279736206564090534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "im-just-a-kid",
      "poi_latitude": "29.5136229",
      "poi_longitude": "-98.5256304",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-802-1924",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ97FnjU_1XIYRpmLNmoLRBmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_1fa739fe94d9112bf9e3bf56",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "The Veranda",
      "poi_type": "Entertainment",
      "poi_address": "1746 Lockhill Selma Rd, San Antonio, TX 78213, USA",
      "poi_short_description": "Unique venue featuring a castle, a courtyard and gardens, plus staff who cater to events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-f11e-741b-938d-d7aa0cba8631.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-f11e-741b-938d-d7aa0cba8631",
        "storage_key": "property/5735011386916864/019f1515-f11e-741b-938d-d7aa0cba8631.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.theverandasa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11020642553017093465&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-veranda",
      "poi_latitude": "29.5361341",
      "poi_longitude": "-98.5218783",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-366-1220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bm6KWdgXIYRWU0jGQMw8Zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wedding_venue"
    },
    {
      "id": "ec_c88910d3da119c95e3ebb361",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Mitchell's Sports Bar",
      "poi_type": "Entertainment",
      "poi_address": "1923 Lockhill Selma Rd, San Antonio, TX 78213, USA",
      "poi_short_description": "Classic sports bar with basic snacks & drinks, plus diversions like pool, darts & video games.",
      "poi_long_description": "Classic sports bar with basic snacks & drinks, plus diversions like pool, darts & video games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-f77e-7482-bf15-2fe3b14c7fc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-f77e-7482-bf15-2fe3b14c7fc4",
        "storage_key": "property/5735011386916864/019f1515-f77e-7482-bf15-2fe3b14c7fc4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.mitchellssportsbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8761104770531617779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mitchells-sports-bar",
      "poi_latitude": "29.5383228",
      "poi_longitude": "-98.5235178",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-979-7720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-3ea8-705e-916a-7dd2d36c08ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1516-3ea8-705e-916a-7dd2d36c08ae",
        "storage_key": "property/5735011386916864/019f1516-3ea8-705e-916a-7dd2d36c08ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYS6Qo2BgXIYR82uE116ylXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "ec_d733a89b8a2d10fe600f92fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "The Urban Ecology Center",
      "poi_type": "Entertainment",
      "poi_address": "8400 NW Military Hwy, San Antonio, TX 78231, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-0173-72d8-84f1-802890f57506.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-0173-72d8-84f1-802890f57506",
        "storage_key": "property/5735011386916864/019f1516-0173-72d8-84f1-802890f57506.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.philhardbergerpark.org/php-urban-ecology-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=7471221147096710244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-urban-ecology-center",
      "poi_latitude": "29.553187",
      "poi_longitude": "-98.5292446",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-207-5323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk52sjvhgXIYRZPwVjwwcr2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_e3e353473526fd63202e6147",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Holocaust Memorial Museum of San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "12500 NW Military Hwy, San Antonio, TX 78231, USA",
      "poi_short_description": "Modest memorial featuring artifacts and storytelling about the Holocaust.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-072b-70b6-99b8-e65fe6b8bfea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-072b-70b6-99b8-e65fe6b8bfea",
        "storage_key": "property/5735011386916864/019f1516-072b-70b6-99b8-e65fe6b8bfea.webp",
        "width": 1054,
        "height": 1280
      },
      "poi_business_url": "https://www.hmmsa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1110331248687438984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holocaust-memorial-museum-of-san-antonio",
      "poi_latitude": "29.5571878",
      "poi_longitude": "-98.5331809",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-302-6807",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0a9-75b5-9ee8-4d739f4eabbf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0a9-75b5-9ee8-4d739f4eabbf",
        "storage_key": "property/5735011386916864/019f1513-c0a9-75b5-9ee8-4d739f4eabbf.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ23Hqiv5gXIYRiNwHTWOwaA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "ec_83f768b91f3b54c3ec8fcc95",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "The DoSeum",
      "poi_type": "Entertainment",
      "poi_address": "2800 Broadway, San Antonio, TX 78209, USA",
      "poi_short_description": "2-story museum promoting learning & discovery through interactive exhibits & creative programs.",
      "poi_long_description": "2-story museum promoting learning & discovery through interactive exhibits & creative programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-0271-70ea-9dc8-bb92a67f915a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-0271-70ea-9dc8-bb92a67f915a",
        "storage_key": "property/5735011386916864/019f1516-0271-70ea-9dc8-bb92a67f915a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://thedoseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15763963794875614826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-doseum",
      "poi_latitude": "29.4533152",
      "poi_longitude": "-98.4716971",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 210-212-4453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0a9-75b5-9ee8-4d739f4eabbf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0a9-75b5-9ee8-4d739f4eabbf",
        "storage_key": "property/5735011386916864/019f1513-c0a9-75b5-9ee8-4d739f4eabbf.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVWnfJL1XIYRagau5YzZxNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_51612254a9f0252f19bca4d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Witte Museum",
      "poi_type": "Entertainment",
      "poi_address": "3801 Broadway, San Antonio, TX 78209, USA",
      "poi_short_description": "Touring & long-term exhibits about natural history, art & Texas heritage, plus a Science Treehouse.",
      "poi_long_description": "Touring & long-term exhibits about natural history, art & Texas heritage, plus a Science Treehouse.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-93c3-715a-a1a4-34c227a5d55c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-93c3-715a-a1a4-34c227a5d55c",
        "storage_key": "property/5735011386916864/019f1513-93c3-715a-a1a4-34c227a5d55c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wittemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14696973662473378755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "witte-museum",
      "poi_latitude": "29.46197799999999",
      "poi_longitude": "-98.4669496",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 210-357-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0a9-75b5-9ee8-4d739f4eabbf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0a9-75b5-9ee8-4d739f4eabbf",
        "storage_key": "property/5735011386916864/019f1513-c0a9-75b5-9ee8-4d739f4eabbf.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8SkZWZf1XIYRw1v_mK0j9ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_9babc138547b92d445c9fb22",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "McNay Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "6000 N New Braunfels Ave, San Antonio, TX 78209, USA",
      "poi_short_description": "American & European art (from Medieval to contemporary) in a 1929 mansion with a modern addition.",
      "poi_long_description": "American & European art (from Medieval to contemporary) in a 1929 mansion with a modern addition.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-909c-753e-8b7a-1fa7808c0828.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-909c-753e-8b7a-1fa7808c0828",
        "storage_key": "property/5735011386916864/019f1513-909c-753e-8b7a-1fa7808c0828.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.mcnayart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=401667984493421393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcnay-art-museum",
      "poi_latitude": "29.4856801",
      "poi_longitude": "-98.4570958",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 210-824-5368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0a9-75b5-9ee8-4d739f4eabbf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0a9-75b5-9ee8-4d739f4eabbf",
        "storage_key": "property/5735011386916864/019f1513-c0a9-75b5-9ee8-4d739f4eabbf.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQzg3fxL1XIYRUaNgXecCkwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_d744dd87057acfcce4c59bf7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Santikos Palladium",
      "poi_type": "Entertainment",
      "poi_address": "17703 W Interstate 10 Frontage Rd, San Antonio, TX 78257, USA",
      "poi_short_description": "Upscale movie theater with a full food & drink menu, plus table seating & wait service.",
      "poi_long_description": "Upscale movie theater with a full food & drink menu, plus table seating & wait service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-0931-7779-9204-8aa2a4aad327.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-0931-7779-9204-8aa2a4aad327",
        "storage_key": "property/5735011386916864/019f1516-0931-7779-9204-8aa2a4aad327.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.santikos.com/san-antonio/palladium/theater-info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8534017591422902188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santikos-palladium",
      "poi_latitude": "29.6085339",
      "poi_longitude": "-98.5992852",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 877-691-0734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-3e9a-742e-ae67-8e76def89a18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1516-3e9a-742e-ae67-8e76def89a18",
        "storage_key": "property/5735011386916864/019f1516-3e9a-742e-ae67-8e76def89a18.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ZDq_iNkXIYRrF-yw8jrbnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_a18a2c7bfb9853a57fb4869a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Six Flags Fiesta Texas",
      "poi_type": "Entertainment",
      "poi_address": "San Antonio, TX 78257, USA",
      "poi_short_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_long_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-12d5-76b9-b2dc-7129118877d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-12d5-76b9-b2dc-7129118877d4",
        "storage_key": "property/5735011386916864/019f1516-12d5-76b9-b2dc-7129118877d4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/fiestatexas?utm_source=googlebusinessprofile&utm_medium=organic&utm_campaign=Google+Business+Profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=2548967654066146973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "six-flags-fiesta-texas",
      "poi_latitude": "29.5993818",
      "poi_longitude": "-98.6088838",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 210-697-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN55XmxZlXIYRnc6SjJPAXyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_53717bfe1bdba9791dc66dce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "The Shops at La Cantera",
      "poi_type": "Entertainment",
      "poi_address": "15900 La Cantera Pkwy Ste 6698, San Antonio, TX 78256, USA",
      "poi_short_description": "Upscale shopping center along an outdoor mall-style walkway with a wide variety of restaurants, shops and food options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-1349-73e6-bace-ea872720c128.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-1349-73e6-bace-ea872720c128",
        "storage_key": "property/5735011386916864/019f1516-1349-73e6-bace-ea872720c128.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.theshopsatlacantera.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11016393100736632124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-shops-at-la-cantera",
      "poi_latitude": "29.5922066",
      "poi_longitude": "-98.6153483",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-582-6255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c169-70dd-943b-0472913bac5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c169-70dd-943b-0472913bac5e",
        "storage_key": "property/5735011386916864/019f1513-c169-70dd-943b-0472913bac5e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4RQtcodmXIYRPJV4YygX4pg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_7f6c54740b832d4915808aa4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Injury and Health Urgent Care - San Antonio",
      "poi_type": "Health and Wellness",
      "poi_address": "1626 Lockhill Selma Rd., Castle Hills, San Antonio, TX 78213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-0b6a-776b-bee8-94dde7b9466b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-0b6a-776b-bee8-94dde7b9466b",
        "storage_key": "property/5735011386916864/019f1516-0b6a-776b-bee8-94dde7b9466b.webp",
        "width": 480,
        "height": 360
      },
      "poi_business_url": "https://www.injuryandhealthurgentcare.com/?utm_source=gmb_auth",
      "poi_directions_map_url": "https://maps.google.com/?cid=5259351477073972294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "injury-and-health-urgent-care---san-antonio",
      "poi_latitude": "29.5333997",
      "poi_longitude": "-98.5199032",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-265-5920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbwMrFU9hXIYRRozrm034_Eg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_a892994f18309aaf4369ed47",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Methodist Hospital Stone Oak",
      "poi_type": "Health and Wellness",
      "poi_address": "1139 E Sonterra Blvd, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-120f-707a-b8ec-f6f95a643c78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-120f-707a-b8ec-f6f95a643c78",
        "storage_key": "property/5735011386916864/019f1516-120f-707a-b8ec-f6f95a643c78.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.sahealth.com/locations/methodist-hospital-stone-oak?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7066658014942627455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "methodist-hospital-stone-oak",
      "poi_latitude": "29.6162229",
      "poi_longitude": "-98.4743864",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 210-638-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0bc-724c-a917-d26675fb1bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0bc-724c-a917-d26675fb1bd8",
        "storage_key": "property/5735011386916864/019f1513-c0bc-724c-a917-d26675fb1bd8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4q-ivmJXIYRf4bSGQbQEWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_55f7a6cf2b72c4d6821ddbb7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "H-E-B Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "6000 West Ave, San Antonio, TX 78213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-12c7-743d-a04e-b68428627d8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-12c7-743d-a04e-b68428627d8b",
        "storage_key": "property/5735011386916864/019f1516-12c7-743d-a04e-b68428627d8b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/pharmacy/common/landing?utm_source=google&utm_medium=organic&utm_campaign=gmb_pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=12646640996270683011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-pharmacy",
      "poi_latitude": "29.515089",
      "poi_longitude": "-98.524331",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-341-3875",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-3ea9-743d-ac83-60c47852d4dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1516-3ea9-743d-ac83-60c47852d4dd",
        "storage_key": "property/5735011386916864/019f1516-3ea9-743d-ac83-60c47852d4dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0l6fX9gXIYRgzObOPvkga8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_3812970d74b0791c80c8884b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "6915 West Ave, Castle Hills, TX 78213, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-dcdd-73a8-b741-d379ce433327.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-dcdd-73a8-b741-d379ce433327",
        "storage_key": "property/5735011386916864/019f1515-dcdd-73a8-b741-d379ce433327.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/castle-hills-tx-pharmacies/6915-w-ave-castle-hills-tx-78213/storeid=7306?WT.mc_id=LS_GOOGLE_FS_7306",
      "poi_directions_map_url": "https://maps.google.com/?cid=15896696319467705805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "29.5328276",
      "poi_longitude": "-98.5234838",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-341-1487",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU5TA_WNgXIYRzdUhCBRpnNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_97c0c9b4114f1f3b4686c330",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "10411 West Ave, San Antonio, TX 78213, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1515-dd04-7216-9c1b-d13af6cca829.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-dd04-7216-9c1b-d13af6cca829",
        "storage_key": "property/5735011386916864/019f1515-dd04-7216-9c1b-d13af6cca829.webp",
        "width": 1280,
        "height": 870
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-10411+west+ave-san+antonio-tx-78213/id=4374",
      "poi_directions_map_url": "https://maps.google.com/?cid=15190032250742520052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.535844",
      "poi_longitude": "-98.5206179",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-979-6575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVFG_2ZgXIYR9Dg8ENrVzdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_3c5c3e1beab1c01fa3aba019",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8055 West Ave, Castle Hills, TX 78213, USA",
      "poi_short_description": "Chain gym offering 24/7 access, plus group workouts and one-on-one training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-1dbc-7479-a1c4-403a349e373f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-1dbc-7479-a1c4-403a349e373f",
        "storage_key": "property/5735011386916864/019f1516-1dbc-7479-a1c4-403a349e373f.webp",
        "width": 1280,
        "height": 870
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/castle-hills-texas-3734/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=3734",
      "poi_directions_map_url": "https://maps.google.com/?cid=217049102969248818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "29.535059",
      "poi_longitude": "-98.5218156",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-366-9001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QQN3WZgXIYRMpxMWQIdAwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_afd15e745428b3c721aeeeb2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Gold's Gym San Antonio Lockhill Village",
      "poi_type": "Health and Wellness",
      "poi_address": "2323 Lockhill Selma Rd, San Antonio, TX 78230, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-18be-77ac-9c5b-a4cb02ca975b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-18be-77ac-9c5b-a4cb02ca975b",
        "storage_key": "property/5735011386916864/019f1516-18be-77ac-9c5b-a4cb02ca975b.webp",
        "width": 1024,
        "height": 597
      },
      "poi_business_url": "https://www.goldsgym.com/lockhill-village/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3008382455638692278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golds-gym-san-antonio-lockhill-village",
      "poi_latitude": "29.5433084",
      "poi_longitude": "-98.530063",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-907-7746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM__vwPVgXIYRtpHcgOfrvyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_2b5f6fbb79131f876cef3d48",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Fieldhouse San Antonio",
      "poi_type": "Health and Wellness",
      "poi_address": "2267 NW Military Hwy #116, San Antonio, TX 78213, USA",
      "poi_short_description": "Gym providing crossfit and weightlifting classes alongside personal coaching.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-1ea0-71d0-9fe5-c37834b735b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-1ea0-71d0-9fe5-c37834b735b4",
        "storage_key": "property/5735011386916864/019f1516-1ea0-71d0-9fe5-c37834b735b4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fieldhousesa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11250235529225840197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fieldhouse-san-antonio",
      "poi_latitude": "29.5378485",
      "poi_longitude": "-98.5244478",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-504-5910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1dYTh2BgXIYRRSb8hpvdIJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_775da2d8b336878b4d70a886",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Yoga Kurunta Rope Wall",
      "poi_type": "Health and Wellness",
      "poi_address": "2147 NW Military Hwy #1, Castle Hills, TX 78213, USA",
      "poi_short_description": "Relaxed yoga studio featuring vinyasa flow and Iyengar rope wall classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-2391-70cb-b8f5-47e29dbd354f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-2391-70cb-b8f5-47e29dbd354f",
        "storage_key": "property/5735011386916864/019f1516-2391-70cb-b8f5-47e29dbd354f.webp",
        "width": 1280,
        "height": 909
      },
      "poi_business_url": "https://www.yogakuruntasa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15004223624967009490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yoga-kurunta-rope-wall",
      "poi_latitude": "29.5316437",
      "poi_longitude": "-98.5212359",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-267-9821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeTxtEw1hXIYR0rSuIOS1OdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_f41dd50d6606c1d90a47164a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "North Central Baptist Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "520 Madison Oak Dr, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-2461-767a-bfc4-114e79de1b54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-2461-767a-bfc4-114e79de1b54",
        "storage_key": "property/5735011386916864/019f1516-2461-767a-bfc4-114e79de1b54.webp",
        "width": 1280,
        "height": 865
      },
      "poi_business_url": "https://www.baptisthealthsystem.com/locations/detail/north-central-baptist-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=9906410289780053303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-central-baptist-hospital",
      "poi_latitude": "29.6204476",
      "poi_longitude": "-98.4908558",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-297-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0bc-724c-a917-d26675fb1bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0bc-724c-a917-d26675fb1bd8",
        "storage_key": "property/5735011386916864/019f1513-c0bc-724c-a917-d26675fb1bd8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwCXMoxjXIYRN1WdEayjeok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_c72ca9cb4b5d62ff176edb40",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "The Urban Ecology Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8400 NW Military Hwy, San Antonio, TX 78231, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-0173-72d8-84f1-802890f57506.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-0173-72d8-84f1-802890f57506",
        "storage_key": "property/5735011386916864/019f1516-0173-72d8-84f1-802890f57506.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.philhardbergerpark.org/php-urban-ecology-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=7471221147096710244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-urban-ecology-center",
      "poi_latitude": "29.553187",
      "poi_longitude": "-98.5292446",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-207-5323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk52sjvhgXIYRZPwVjwwcr2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_1fcba846c5580c78e881e48e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Walker Ranch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12603 West Ave, San Antonio, TX 78216, USA",
      "poi_short_description": "Grassy, tree-filled park offering walking trails, a big playground & picnic shelter.",
      "poi_long_description": "Grassy, tree-filled park offering walking trails, a big playground & picnic shelter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-2979-722a-b59b-6d1ba754a76c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-2979-722a-b59b-6d1ba754a76c",
        "storage_key": "property/5735011386916864/019f1516-2979-722a-b59b-6d1ba754a76c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2467/Walker-Ranch/Park/250",
      "poi_directions_map_url": "https://maps.google.com/?cid=5256102213650417887&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walker-ranch-park",
      "poi_latitude": "29.55616699999999",
      "poi_longitude": "-98.5002317",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-207-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c16e-7483-a3ed-03cab4d55f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c16e-7483-a3ed-03cab4d55f04",
        "storage_key": "property/5735011386916864/019f1513-c16e-7483-a3ed-03cab4d55f04.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4RznxTNgXIYR3wjHgx1t8Ug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_351e122ec9c5e6348488ed42",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "McGimsey Scout Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10810 Wedgewood Dr, Castle Hills, TX 78213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-1cc6-756f-8608-aed81bbd5c84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-1cc6-756f-8608-aed81bbd5c84",
        "storage_key": "property/5735011386916864/019f1516-1cc6-756f-8608-aed81bbd5c84.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.alamoareascouting.org/about-us/our-camps/mcgimsey-scout-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10886159314401051855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcgimsey-scout-park",
      "poi_latitude": "29.5377578",
      "poi_longitude": "-98.5315769",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-341-8611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4wt_WgBhXIYRz0QvFzhoE5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "ec_c212ed01702f07d266e8f7ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Rice Road Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Salado Creek Greenway S, San Antonio, TX 78220, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-285d-749f-a227-d03d3ab75d98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-285d-749f-a227-d03d3ab75d98",
        "storage_key": "property/5735011386916864/019f1516-285d-749f-a227-d03d3ab75d98.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6670444155320688991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rice-road-trailhead",
      "poi_latitude": "29.4090387",
      "poi_longitude": "-98.419031",
      "poi_miles_from_property": "14.0 mi",
      "poi_walking_minutes": "5 hours 11 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c16e-7483-a3ed-03cab4d55f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c16e-7483-a3ed-03cab4d55f04",
        "storage_key": "property/5735011386916864/019f1513-c16e-7483-a3ed-03cab4d55f04.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcdy4epX2XIYRX2H4I54tklw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1df29d3150e59bb9a286eb02",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Oakwell Trailhead Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "150 Ira Lee Rd, San Antonio, TX 78218, USA",
      "poi_short_description": "Trailhead for a 2.1-mile greenway path for hiking & biking, plus picnic tables by a local artist.",
      "poi_long_description": "Trailhead for a 2.1-mile greenway path for hiking & biking, plus picnic tables by a local artist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-22d4-7568-9a8a-4f6656df5695.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-22d4-7568-9a8a-4f6656df5695",
        "storage_key": "property/5735011386916864/019f1516-22d4-7568-9a8a-4f6656df5695.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16565093249423972388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oakwell-trailhead-park",
      "poi_latitude": "29.50216319999999",
      "poi_longitude": "-98.4210044",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c16e-7483-a3ed-03cab4d55f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c16e-7483-a3ed-03cab4d55f04",
        "storage_key": "property/5735011386916864/019f1513-c16e-7483-a3ed-03cab4d55f04.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk_85esb0XIYRJBgjc4sI4-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e5b972b1f2fefa1690ae5063",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "McAllister Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13102 Jones Maltsberger Rd, San Antonio, TX 78247, USA",
      "poi_short_description": "Natural area with jogging & biking trails, picnic spots, a dog park, playscapes & athletic fields.",
      "poi_long_description": "Natural area with jogging & biking trails, picnic spots, a dog park, playscapes & athletic fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-a312-71fa-a0c4-f24d284d615c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-a312-71fa-a0c4-f24d284d615c",
        "storage_key": "property/5735011386916864/019f1513-a312-71fa-a0c4-f24d284d615c.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2578/McAllister-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1871900702508716191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcallister-park",
      "poi_latitude": "29.563045",
      "poi_longitude": "-98.4542279",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c16e-7483-a3ed-03cab4d55f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c16e-7483-a3ed-03cab4d55f04",
        "storage_key": "property/5735011386916864/019f1513-c16e-7483-a3ed-03cab4d55f04.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJa-WcPyKXIYRnxDWa8VT-hk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_4df80b53dc21a7512f08da47",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Bamberger Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12401 Babcock Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "This tree-filled natural area offers trails for hiking & cycling, plus a playground.",
      "poi_long_description": "This tree-filled natural area offers trails for hiking & cycling, plus a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-31c1-7258-b7d6-f65492c47569.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-31c1-7258-b7d6-f65492c47569",
        "storage_key": "property/5735011386916864/019f1516-31c1-7258-b7d6-f65492c47569.webp",
        "width": 1280,
        "height": 1018
      },
      "poi_business_url": "https://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2435/Bamberger-Nature-Park?Park=11&Facility=",
      "poi_directions_map_url": "https://maps.google.com/?cid=1927048889006278731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bamberger-nature-park",
      "poi_latitude": "29.5610152",
      "poi_longitude": "-98.6291246",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c16e-7483-a3ed-03cab4d55f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c16e-7483-a3ed-03cab4d55f04",
        "storage_key": "property/5735011386916864/019f1513-c16e-7483-a3ed-03cab4d55f04.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJawzKcU5mXIYRS8gHLsFAvho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_21e8f92d29e8e9d1e9dc044a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Crystal Hill Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4909 Crystal Hill, San Antonio, TX 78238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-2bdc-77f6-a9ec-5e598b272135.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-2bdc-77f6-a9ec-5e598b272135",
        "storage_key": "property/5735011386916864/019f1516-2bdc-77f6-a9ec-5e598b272135.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15321521461020576137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crystal-hill-trailhead",
      "poi_latitude": "29.4789113",
      "poi_longitude": "-98.6199557",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c16e-7483-a3ed-03cab4d55f04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c16e-7483-a3ed-03cab4d55f04",
        "storage_key": "property/5735011386916864/019f1513-c16e-7483-a3ed-03cab4d55f04.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWPO1oxdXIYRicmnhpf6oNQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c93e2c84b063189becdfcf34",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Lockhill-Selma & Wedgewood Dr.",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78230, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-2e47-770a-b7c1-34f66307ed04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-2e47-770a-b7c1-34f66307ed04",
        "storage_key": "property/5735011386916864/019f1516-2e47-770a-b7c1-34f66307ed04.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3044137696657407726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lockhill-selma--wedgewood-dr",
      "poi_latitude": "29.541407",
      "poi_longitude": "-98.528569",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT003hPVgXIYR7v6jSBvzPio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_e060902097fe0fd32c34509c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Lockhill-Selma & West Ave.",
      "poi_type": "Transportation & Transit",
      "poi_address": "Castle Hills, TX 78213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9199137989510809000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lockhill-selma--west-ave",
      "poi_latitude": "29.535159",
      "poi_longitude": "-98.520631",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBy3S5GZgXIYRqMWXKEPnqX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_258f0de76866754e5f312b50",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Lockhill-Selma & Bel Air",
      "poi_type": "Transportation & Transit",
      "poi_address": "Castle Hills, TX 78213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-2f70-76a7-bf16-abff7c854856.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-2f70-76a7-bf16-abff7c854856",
        "storage_key": "property/5735011386916864/019f1516-2f70-76a7-bf16-abff7c854856.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5373880999815593136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lockhill-selma--bel-air",
      "poi_latitude": "29.540037",
      "poi_longitude": "-98.526793",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIaI4ll9gXIYRsLw6G0zck0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_a20a53fe097f7b0ca1b1385f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Military Hwy. & Lockhill Selma",
      "poi_type": "Transportation & Transit",
      "poi_address": "Castle Hills, TX 78213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13008040454478876034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "military-hwy--lockhill-selma",
      "poi_latitude": "29.540165",
      "poi_longitude": "-98.527317",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsehekF9gXIYRgs0fsd_XhbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_6ccd1f3f661599109b0a57df",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "VIA Stone Oak Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "22139 US-281, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-2f71-72aa-a3dc-0db6118b0a59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-2f71-72aa-a3dc-0db6118b0a59",
        "storage_key": "property/5735011386916864/019f1516-2f71-72aa-a3dc-0db6118b0a59.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.viainfo.net/park-ride-commuting/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18423806789292463184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-stone-oak-park--ride",
      "poi_latitude": "29.6480735",
      "poi_longitude": "-98.452267",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 24 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-362-2887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-3eba-7506-b124-d007dce372c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1516-3eba-7506-b124-d007dce372c1",
        "storage_key": "property/5735011386916864/019f1516-3eba-7506-b124-d007dce372c1.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47WvqEaJXIYRUBQ1TqmCrv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_e2e52f1b499f39be2b21c42d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "VIA Crossroads Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "151 N Crossroads Blvd, Balcones Heights, TX 78201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-3357-754a-8abe-5c851965f0d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-3357-754a-8abe-5c851965f0d1",
        "storage_key": "property/5735011386916864/019f1516-3357-754a-8abe-5c851965f0d1.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "http://viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14912817806174523366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-crossroads-park--ride",
      "poi_latitude": "29.493575",
      "poi_longitude": "-98.5483679",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-362-2892",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-3eba-7506-b124-d007dce372c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1516-3eba-7506-b124-d007dce372c1",
        "storage_key": "property/5735011386916864/019f1516-3eba-7506-b124-d007dce372c1.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJNXQTzYRfXIYR5g8ngcj49M4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_a8c6f9211277a9a6b1a8ec06",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "North Star Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7538 San Pedro Ave, San Antonio, TX 78216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-2fc8-714e-a97c-8437e29aa186.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-2fc8-714e-a97c-8437e29aa186",
        "storage_key": "property/5735011386916864/019f1516-2fc8-714e-a97c-8437e29aa186.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10414624133700210677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-star-transit-center",
      "poi_latitude": "29.51912",
      "poi_longitude": "-98.49871",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-409-7788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRbAqpAlgXIYR9U9pdngtiJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_980667e7b034a15d8415df2d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "VIA Metro Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1021 San Pedro Ave, San Antonio, TX 78212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-36bd-740a-8d37-78bb87e79c5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-36bd-740a-8d37-78bb87e79c5d",
        "storage_key": "property/5735011386916864/019f1516-36bd-740a-8d37-78bb87e79c5d.webp",
        "width": 949,
        "height": 1280
      },
      "poi_business_url": "http://www.viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7516257581784255112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-metro-center",
      "poi_latitude": "29.4431317",
      "poi_longitude": "-98.4997932",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-362-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Qgl6ENfXIYRiEqWonIcT2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_9fb0bbce76c0c9c7a5c40785",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "San Antonio International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "9800 Airport Blvd, San Antonio, TX 78216, USA",
      "poi_short_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_long_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-a313-754a-bd8b-b7bf87a87255.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-a313-754a-bd8b-b7bf87a87255",
        "storage_key": "property/5735011386916864/019f1513-a313-754a-bd8b-b7bf87a87255.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.flysanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18041828760938859602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-international-airport",
      "poi_latitude": "29.5331282",
      "poi_longitude": "-98.4705422",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-207-3433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c125-74c6-8366-168c03c84a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c125-74c6-8366-168c03c84a58",
        "storage_key": "property/5735011386916864/019f1513-c125-74c6-8366-168c03c84a58.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4DLsbuKXIYRUswvGqtzYfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_7f486f92dd82dfb7ad4fcbe3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Rackspace Technology",
      "poi_type": "Major Employers & Offices",
      "poi_address": "19122 U.S. Hwy 281 N Ste 128, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-3594-715b-88e6-5394b2638c23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-3594-715b-88e6-5394b2638c23",
        "storage_key": "property/5735011386916864/019f1516-3594-715b-88e6-5394b2638c23.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.rackspace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10903605575149915578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rackspace-technology",
      "poi_latitude": "29.6183163",
      "poi_longitude": "-98.4634525",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-961-4454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkc1iXP7zXIYRuo3HNYBjUZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_421e51c20970c2e024b13af9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Methodist Hospital Stone Oak",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1139 E Sonterra Blvd, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-120f-707a-b8ec-f6f95a643c78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-120f-707a-b8ec-f6f95a643c78",
        "storage_key": "property/5735011386916864/019f1516-120f-707a-b8ec-f6f95a643c78.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.sahealth.com/locations/methodist-hospital-stone-oak?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7066658014942627455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "methodist-hospital-stone-oak",
      "poi_latitude": "29.6162229",
      "poi_longitude": "-98.4743864",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 210-638-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0bc-724c-a917-d26675fb1bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0bc-724c-a917-d26675fb1bd8",
        "storage_key": "property/5735011386916864/019f1513-c0bc-724c-a917-d26675fb1bd8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4q-ivmJXIYRf4bSGQbQEWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_ea0de15b5b18c03daeaa90e0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "North Central Baptist Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "520 Madison Oak Dr, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-2461-767a-bfc4-114e79de1b54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-2461-767a-bfc4-114e79de1b54",
        "storage_key": "property/5735011386916864/019f1516-2461-767a-bfc4-114e79de1b54.webp",
        "width": 1280,
        "height": 865
      },
      "poi_business_url": "https://www.baptisthealthsystem.com/locations/detail/north-central-baptist-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=9906410289780053303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-central-baptist-hospital",
      "poi_latitude": "29.6204476",
      "poi_longitude": "-98.4908558",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-297-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0bc-724c-a917-d26675fb1bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0bc-724c-a917-d26675fb1bd8",
        "storage_key": "property/5735011386916864/019f1513-c0bc-724c-a917-d26675fb1bd8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwCXMoxjXIYRN1WdEayjeok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_1098d9ac8a6ddcf07bffd07e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "St. Luke's Baptist Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7930 Floyd Curl Dr, San Antonio, TX 78229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-3570-729d-8493-4bfaf204e651.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-3570-729d-8493-4bfaf204e651",
        "storage_key": "property/5735011386916864/019f1516-3570-729d-8493-4bfaf204e651.webp",
        "width": 900,
        "height": 569
      },
      "poi_business_url": "https://www.baptisthealthsystem.com/location/detail/st-lukes-baptist-hospital/?utm_campaign=gmb_listings_mgmt&utm_source=gmb-st-lukes-baptist-hospital&utm_medium=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1680511775295319389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-lukes-baptist-hospital",
      "poi_latitude": "29.5124793",
      "poi_longitude": "-98.5750694",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 210-297-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0bc-724c-a917-d26675fb1bd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0bc-724c-a917-d26675fb1bd8",
        "storage_key": "property/5735011386916864/019f1513-c0bc-724c-a917-d26675fb1bd8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJy10af1VnXIYRXa1WT45gUhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_0ae7f9478ca4e9b007eb4588",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "UT Health San Antonio | University of Texas Health Science Center at San Antonio",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7703 Floyd Curl Dr, San Antonio, TX 78229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-360f-7027-bbac-2924a58684df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-360f-7027-bbac-2924a58684df",
        "storage_key": "property/5735011386916864/019f1516-360f-7027-bbac-2924a58684df.webp",
        "width": 743,
        "height": 492
      },
      "poi_business_url": "https://uthscsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3360406320502522370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ut-health-san-antonio--university-of-texas-health-science-center-at-san-antonio",
      "poi_latitude": "29.50809589999999",
      "poi_longitude": "-98.575681",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-567-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnS9zQ_5dXIYRAsKHir6Poi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_7236f0007f319954530460ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Northside Independent School District Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5900 Evers Rd, San Antonio, TX 78238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://nisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=592429851399403552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northside-independent-school-district-administration-building",
      "poi_latitude": "29.4908341",
      "poi_longitude": "-98.6012233",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 210-397-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0aa-708c-8dcb-770c5995a6d1",
        "storage_key": "property/5735011386916864/019f1513-c0aa-708c-8dcb-770c5995a6d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx7e68JZdXIYRILj_ns-7OAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_b6684d2ad8b99fa44e4a3fc3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "San Antonio International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9800 Airport Blvd, San Antonio, TX 78216, USA",
      "poi_short_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_long_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-a313-754a-bd8b-b7bf87a87255.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-a313-754a-bd8b-b7bf87a87255",
        "storage_key": "property/5735011386916864/019f1513-a313-754a-bd8b-b7bf87a87255.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.flysanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18041828760938859602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-international-airport",
      "poi_latitude": "29.5331282",
      "poi_longitude": "-98.4705422",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-207-3433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c125-74c6-8366-168c03c84a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c125-74c6-8366-168c03c84a58",
        "storage_key": "property/5735011386916864/019f1513-c125-74c6-8366-168c03c84a58.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4DLsbuKXIYRUswvGqtzYfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_8bfc8c7f572d9e7254dd440e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "USAA Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9800 Fredericksburg Rd, San Antonio, TX 78288, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-af7f-727b-9d05-bd3bcc718e99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-af7f-727b-9d05-bd3bcc718e99",
        "storage_key": "property/5735011386916864/019f1513-af7f-727b-9d05-bd3bcc718e99.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.usaa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7341051404387659836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "usaa-corporate-office",
      "poi_latitude": "29.5371902",
      "poi_longitude": "-98.5752478",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-531-8722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyyb6ITJnXIYRPLBolFun4GU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_3db848c0ea1ebab2bebb5051",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "Toyota Motor Manufacturing, Texas, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Lone Star Pass, San Antonio, TX 78264, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-3786-762d-af24-c57400b05bc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-3786-762d-af24-c57400b05bc6",
        "storage_key": "property/5735011386916864/019f1516-3786-762d-af24-c57400b05bc6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.toyota.com/usa/operations/map/tmmtx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3739277978480632304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toyota-motor-manufacturing-texas-inc",
      "poi_latitude": "29.2574587",
      "poi_longitude": "-98.5429684",
      "poi_miles_from_property": "20.9 mi",
      "poi_walking_minutes": "7 hours 42 mins",
      "poi_biking_minutes": "2 hours 10 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt-W_7exWXIYR8GHHh4KV5DM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_4555197360e0adebbf6b7459",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "poi_name": "H-E-B Corporate Office Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "646 S Flores St, San Antonio, TX 78204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1516-373b-735c-ace2-8e4963217364.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-373b-735c-ace2-8e4963217364",
        "storage_key": "property/5735011386916864/019f1516-373b-735c-ace2-8e4963217364.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/static-page/heb-corporate-office-hq",
      "poi_directions_map_url": "https://maps.google.com/?cid=10485037645668446608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-corporate-office-headquarters",
      "poi_latitude": "29.4172323",
      "poi_longitude": "-98.4954226",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-938-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-c0b7-75af-b67a-65f3945cdeee",
        "storage_key": "property/5735011386916864/019f1513-c0b7-75af-b67a-65f3945cdeee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHfrImLFYXIYRkHGqxi9WgpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_394e6919-629c-4b8f-bd89-4eaff500a720",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6d2000c8-68b8-4c18-b27d-d3dd34fbc045",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_659e8fbc-dd9a-4002-a4ec-57728c226bf1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0ae5b585-2d32-47f5-a462-27918a051c82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ba7f9d1b-7212-421b-97d3-a0363054c05b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_e16bc3f3-40a7-4e88-a203-b5ecb8c3846d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "19:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_b971b9b590ed28a1735c9101",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "rating": "5",
      "name": "L",
      "text": "The Alon is a parklike atmospheric complex with a really pretty pool and nice picnic areas. The management team is super caring and fun. They've hosted nice events like Bingo and a beautiful Italian dinner. They work hard to create a fun , safe a clean environment for their tenants. The maintenance staff is helpful, courteous and does everything to try to get things taken care of. The grounds are clean and they are pet friendly. They have doggie bags if ya need one..lol..They keep residents informed of  events and also house rules. Alon's management team is  people oriented and approachable. They have considerate attitudes and do what they can to help their residents  Alon offers array of services like Valet trash pick up, and a place where you can pick up your ordered packages,. You can get a nice cup of coffee or tea, and you can catch a movie in their theater..( too cute! ) . It's really a very nice place to live.❣️",
      "date": "2026-01-06",
      "title": "false"
    },
    {
      "id": "ec_7ad4a78237326aaf10377392",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "rating": "5",
      "name": "Barbar Davila",
      "text": "I recently moved in and had an amazing experience with the office staff. Aunna was extremely thorough in answering all of my questions and addressing my concerns. After seeing some reviews about towing, I asked for clarification and was reassured that proper steps are taken before any action occurs. I think people are often more likely to leave reviews when they’re upset rather than when they’ve had a great experience, so I wanted to take the time to share mine. The office staff is truly top-tier, and I appreciate their professionalism and transparency.",
      "date": "2026-01-05",
      "title": "false"
    },
    {
      "id": "ec_ddee3fb59b7d63b93138b2ae",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "rating": "5",
      "name": "Alejandro Urias",
      "text": "A good friend of mine moved in about two months ago, management made the process really smooth! They were very attentive and professional. The community always looks clean and it looks like the office enforces the community policies as the property is so nice! One of my top communities on my list to consider to move once my lease expires.",
      "date": "2026-01-04",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_40d277d5b53cb9dc9be0e8b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019d02f3-59a9-76d5-a3b7-cf1ca0fc060c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and dining area with a desk and view into kitchen.",
        "public_id": "019d02f3-59a9-76d5-a3b7-cf1ca0fc060c",
        "storage_key": "property/5735011386916864/019d02f3-59a9-76d5-a3b7-cf1ca0fc060c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 927SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=LuFF1FCc5SA"
    },
    {
      "id": "ec_36f3d586f1743297e89adcde",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019d02f3-5018-71b9-b27d-87b802c45e02.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Fitness center with treadmills, stationary bikes, and weight machines.",
        "public_id": "019d02f3-5018-71b9-b27d-87b802c45e02",
        "storage_key": "property/5735011386916864/019d02f3-5018-71b9-b27d-87b802c45e02.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=KsenCcSd5Un"
    },
    {
      "id": "ec_fbd54b67b5a164d6c3487a57",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019d02f3-4fa3-7666-a6f1-962e04c3f692.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious community lounge area with a large sectional sofa, coffee table, and accent rug.",
        "public_id": "019d02f3-4fa3-7666-a6f1-962e04c3f692",
        "storage_key": "property/5735011386916864/019d02f3-4fa3-7666-a6f1-962e04c3f692.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Leasing Office",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=f7KJJ4ZrsHe"
    },
    {
      "id": "ec_cce781fb37c2b96b264df18e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019d02f3-59ab-71f1-bbe6-33485db06694.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Waiting area with two orange chairs and a TV mounted on the wall.",
        "public_id": "019d02f3-59ab-71f1-bbe6-33485db06694",
        "storage_key": "property/5735011386916864/019d02f3-59ab-71f1-bbe6-33485db06694.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Business Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=9WKHdvSvJXx"
    },
    {
      "id": "ec_536cc85c3a3abf55cd88dfbb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019d02f3-4f9e-7208-af9f-7ebe3286deea.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Community movie theater with tiered seating and vintage movie posters.",
        "public_id": "019d02f3-4f9e-7208-af9f-7ebe3286deea",
        "storage_key": "property/5735011386916864/019d02f3-4f9e-7208-af9f-7ebe3286deea.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Movie Theater",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=SNeZ9fyqePT"
    },
    {
      "id": "ec_101ab77b10192b9bdb009fbc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019d02f3-5015-730e-8f3b-4f259911d254.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Clubhouse common area with a coffee bar, dining table, and pool table.",
        "public_id": "019d02f3-5015-730e-8f3b-4f259911d254",
        "storage_key": "property/5735011386916864/019d02f3-5015-730e-8f3b-4f259911d254.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=owPhsP1L96n"
    }
  ],
  "faqs": [
    {
      "id": "custom_5fab7719-276b-4843-9b7b-b972c52e8219",
      "question": "Is Alon at Castle Hills pet-friendly?",
      "answer": "Yes. Alon at Castle Hills welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (210) 342-5151 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_3bea885c-41ad-4a29-9740-e76dbc3735ae",
      "question": "How can I schedule a tour at Alon at Castle Hills?",
      "answer": "You can schedule a tour of Alon at Castle Hills online through our Schedule a Tour page, or call the leasing office at (210) 342-5151. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_df6838e5-9e8d-40bd-b324-e8f4ad8ab89b",
      "question": "What are the leasing office hours at Alon at Castle Hills?",
      "answer": "The Alon at Castle Hills leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 7:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (210) 342-5151 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_f797f044-5ada-454c-8ea0-9dc874425a2c",
      "question": "What floor plans are available at Alon at Castle Hills?",
      "answer": "Alon at Castle Hills offers 1- and 2-bedroom apartment homes ranging from approximately 535 to 1,065 square feet, across 9 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_ec85b000-d985-4dcd-914d-479c341d7be9",
      "question": "What amenities does Alon at Castle Hills have?",
      "answer": "Alon at Castle Hills offers a range of community and in-home amenities. Community amenities include: LUXER Package Locker, Access Gates, American Landmark 360, Billiards, Business Center, Clubhouse, Dog Park, Fitness Center, Online Resident Services, Pool, Select Homes, Theatre Room, and Cyber Cafe. In-home features include: chef`s kitchen, fire, garages, hard floors, kitchen appliances, outside space, storage spaces, w&d connections, and walk-in closet. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_90dc1206-fdc7-49b8-9f19-82ac0f68b375",
      "question": "Where is Alon at Castle Hills located?",
      "answer": "Alon at Castle Hills is located at 1835 Lockhill Selma Rd, Castle Hills TX 78213. Nearby you'll find dining at The Lodge Restaurant of Castle Hills, shopping at H-E-B, and green space at The Urban Ecology Center. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_e3c4db83-b53c-4d99-8181-fe26f4794933",
      "question": "How do I apply to live at Alon at Castle Hills?",
      "answer": "You can apply to live at Alon at Castle Hills online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (210) 342-5151 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_bfd3dbf7-fc74-46d7-bfec-1ff8fe1fc00d",
      "question": "What do I need to apply at Alon at Castle Hills?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Alon at Castle Hills leasing team at (210) 342-5151 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_213c24dd-9d2d-4b80-a0f1-321b1d7ae357",
      "question": "What is the Landmark 360 program at Alon at Castle Hills?",
      "answer": "Alon at Castle Hills participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (210) 342-5151 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_c6811252-c333-47de-bf5a-effc2ceff65b",
      "question": "Does Alon at Castle Hills have a pool?",
      "answer": "Yes. Alon at Castle Hills has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_d17f95e9-1290-4ed0-b639-ecad9615671a",
      "question": "Does Alon at Castle Hills have a fitness center?",
      "answer": "Yes. Alon at Castle Hills has a fitness center for residents. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_6cc9ef27-6e3f-417b-ba3a-c2cb31e66ea9",
      "question": "Does Alon at Castle Hills have a dog park?",
      "answer": "Yes. Alon at Castle Hills has an on-site dog park for residents and their dogs. See more community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_d0fed795-a1bf-434d-977c-c84eadde5161",
      "question": "Does Alon at Castle Hills offer virtual tours?",
      "answer": "Yes. Alon at Castle Hills offers virtual tours of 2BR, 1BA - 927SF, Fitness Center, Leasing Office, Business Center, Movie Theater, and Clubhouse. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_eb1539de-9ee3-400d-a725-6a01f0ce7836",
      "question": "What do residents say about living at Alon at Castle Hills?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Alon at Castle Hills. One resident wrote: *\"I have to admit we love living here and could not imagine living anywhere else in San Antonio. The well-maintained property has a wonderful rustic vibe while being set in a genuinely nice neighborhood.\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_a7995086-13a6-490a-9864-4f669278e39c",
      "question": "When was Alon at Castle Hills built?",
      "answer": "Alon at Castle Hills was built in 2000. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_3886aac2-bf55-43e9-81d2-86c6c7a1c67b",
      "question": "What is the pet fee at Alon at Castle Hills?",
      "answer": "Pets at Alon at Castle Hills: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (210) 342-5151 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_12571647-8e14-4a2f-af59-3ae37b19ebe9",
      "question": "What features are included in the apartments at Alon at Castle Hills?",
      "answer": "Apartment homes at Alon at Castle Hills include chef`s kitchen, fire, garages, hard floors, kitchen appliances, outside space, storage spaces, w&d connections, and walk-in closet. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_6187b2ab-7b86-4b0c-8a9a-aaa346b0e9c1",
      "question": "What restaurants and shops are near Alon at Castle Hills?",
      "answer": "Nearby restaurants and shops include The Lodge Restaurant of Castle Hills, Bee's Mexican Restaurant & Bakery, Santos Cafe #1, and Bilia Eatery. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-2732-7241-98a5-6944ad2e03d7",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "alon-at-castle-hills",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864"
    },
    {
      "lead_collector_id": "0198aa45-2795-7147-bbd3-30461e42bc32",
      "lead_source": "FACEBOOK_ADS",
      "name": "alon-at-castle-hills",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864"
    },
    {
      "lead_collector_id": "0198aa45-27f8-75d0-b2ea-13a7855c145b",
      "lead_source": "LANDING_PAGE",
      "name": "alon-at-castle-hills",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-san-antonio-tx",
      "search_query": "One Bedroom Apartments For Rent In San Antonio TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In San Antonio TX",
      "h2_subtitle": "Discover modern luxury living at Alon at Castle Hills. Our one bedroom apartments offer the upscale lifestyle you’ve been searching for.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our one bedroom apartments for rent in San Antonio, TX, feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Cool off on hot days with a dip in the resort-style swimming pool, or spend your afternoons relaxing with friends in our exclusive resident clubhouse. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | One Bedroom Apartments For Rent In San Antonio TX",
      "seo_description": "Discover modern luxury living at Alon at Castle Hills. Our one bedroom apartments for rent in San Antonio, TX, offer the upscale lifestyle you’ve been searching for.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-san-antonio-tx",
      "search_query": "Two Bedrooms Apartments For Rent In San Antonio TX",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In San Antonio TX",
      "h2_subtitle": "Experience upscale living at Alon at Castle Hills. Our two bedroom apartments offer the perfect blend of luxury and comfort.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our two bedrooms apartments for rent in San Antonio, TX, feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Cool off on hot days with a dip in the resort-style swimming pool, or spend your afternoons relaxing with friends in our exclusive resident clubhouse. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Two Bedrooms Apartments For Rent In San Antonio TX",
      "seo_description": "Experience upscale living at Alon at Castle Hills. Our two bedrooms apartments for rent in San Antonio, TX, offer the perfect blend of luxury and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Pool",
      "h2_subtitle": "Discover luxury living at Alon at Castle Hills. Our apartments offer a resort-style pool and upscale amenities for your comfort.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent near me with pool feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Cool off on hot days with a dip in the resort-style swimming pool, or spend your afternoons relaxing with friends in our exclusive resident clubhouse. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent Near Me with Pool",
      "seo_description": "Discover luxury living at Alon at Castle Hills. Our apartments for rent near me with pool offer a resort-style pool and upscale amenities for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "Experience luxury living at Alon at Castle Hills. Our apartments offer a state-of-the-art fitness center and upscale amenities for your lifestyle.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent near me with fitness center feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Stay active with our state-of-the-art fitness center, or spend your afternoons relaxing with friends in our exclusive resident clubhouse. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Experience luxury living at Alon at Castle Hills. Our apartments for rent near me with fitness center offer a state-of-the-art fitness center and upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-clubhouse",
      "search_query": "Apartments For Rent Near Me with Clubhouse",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Clubhouse",
      "h2_subtitle": "Discover upscale living at Alon at Castle Hills. Our apartments offer an exclusive resident clubhouse and luxurious amenities for your comfort.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent near me with clubhouse feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Spend your afternoons relaxing with friends in our exclusive resident clubhouse, or cool off on hot days with a dip in the resort-style swimming pool. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent Near Me with Clubhouse",
      "seo_description": "Discover upscale living at Alon at Castle Hills. Our apartments for rent near me with clubhouse offer an exclusive resident clubhouse and luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-lounge",
      "search_query": "Apartments For Rent Near Me with Lounge",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Lounge",
      "h2_subtitle": "Experience luxury living at Alon at Castle Hills. Our apartments offer a stylish lounge and upscale amenities for your enjoyment.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent near me with lounge feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Spend your afternoons relaxing with friends in our stylish lounge, or cool off on hot days with a dip in the resort-style swimming pool. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent Near Me with Lounge",
      "seo_description": "Experience luxury living at Alon at Castle Hills. Our apartments for rent near me with lounge offer a stylish lounge and upscale amenities for your enjoyment.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-dog-park",
      "search_query": "Apartments For Rent Near Me with Dog Park",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Dog Park",
      "h2_subtitle": "Discover pet-friendly luxury living at Alon at Castle Hills. Our apartments offer a dedicated dog park and upscale amenities for you and your furry friend.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent near me with dog park feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Spend your afternoons relaxing with friends in our exclusive resident clubhouse, or let your furry friend play in our dedicated dog park. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent Near Me with Dog Park",
      "seo_description": "Discover pet-friendly luxury living at Alon at Castle Hills. Our apartments for rent near me with dog park offer a dedicated dog park and upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-kitchen",
      "search_query": "Apartments For Rent Near Me with Kitchen",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Kitchen",
      "h2_subtitle": "Experience culinary luxury at Alon at Castle Hills. Our apartments offer spacious chef’s kitchens and upscale amenities for your lifestyle.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent near me with kitchen feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Spend your afternoons relaxing with friends in our exclusive resident clubhouse, or cool off on hot days with a dip in the resort-style swimming pool. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent Near Me with Kitchen",
      "seo_description": "Experience culinary luxury at Alon at Castle Hills. Our apartments for rent near me with kitchen offer spacious chef’s kitchens and upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-stainless-steel",
      "search_query": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "h2_subtitle": "Discover modern luxury at Alon at Castle Hills. Our apartments offer stainless steel appliances and upscale amenities for your comfort.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent near me with stainless steel appliances feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Spend your afternoons relaxing with friends in our exclusive resident clubhouse, or cool off on hot days with a dip in the resort-style swimming pool. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent Near Me with Stainless Steel Appliances",
      "seo_description": "Discover modern luxury at Alon at Castle Hills. Our apartments for rent near me with stainless steel appliances offer upscale amenities for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-walk-in-closets",
      "search_query": "Apartments For Rent Near Me with Walk-In Closets",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Walk-In Closets",
      "h2_subtitle": "Discover spacious living at Alon at Castle Hills. Our apartments offer walk-in closets and luxurious amenities for your comfort.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent near me with walk-in closets feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Spend your afternoons relaxing with friends in our exclusive resident clubhouse, or cool off on hot days with a dip in the resort-style swimming pool. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent Near Me with Walk-In Closets",
      "seo_description": "Discover spacious living at Alon at Castle Hills. Our apartments for rent near me with walk-in closets offer luxurious amenities for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-balcony",
      "search_query": "Apartments For Rent Near Me with Balcony",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Balcony",
      "h2_subtitle": "Experience elevated living at Alon at Castle Hills. Our apartments offer private balconies and luxurious amenities for your enjoyment.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent near me with balcony feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Spend your afternoons relaxing with friends in our exclusive resident clubhouse, or cool off on hot days with a dip in the resort-style swimming pool. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent Near Me with Balcony",
      "seo_description": "Experience elevated living at Alon at Castle Hills. Our apartments for rent near me with balcony offer private balconies and luxurious amenities for your enjoyment.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-san-antonio-tx-near-wonderland",
      "search_query": "Apartments For Rent In San Antonio TX Near Wonderland of the Americas",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near Wonderland of the Americas",
      "h2_subtitle": "Discover luxury living at Alon at Castle Hills. Our apartments offer upscale amenities and are conveniently located near Wonderland of the Americas.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near Wonderland of the Americas feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Spend your afternoons relaxing with friends in our exclusive resident clubhouse, or cool off on hot days with a dip in the resort-style swimming pool. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent In San Antonio TX Near Wonderland of the Americas",
      "seo_description": "Discover luxury living at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near Wonderland of the Americas offer upscale amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-in-san-antonio-tx-near-college",
      "search_query": "Apartments For Rent In San Antonio TX Near San Antonio College",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near San Antonio College",
      "h2_subtitle": "Experience luxury living at Alon at Castle Hills. Our apartments offer upscale amenities and are conveniently located near San Antonio College.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near San Antonio College feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Spend your afternoons relaxing with friends in our exclusive resident clubhouse, or cool off on hot days with a dip in the resort-style swimming pool. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent In San Antonio TX Near San Antonio College",
      "seo_description": "Experience luxury living at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near San Antonio College offer upscale amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-san-antonio-tx-near-university-incarnate-word",
      "search_query": "Apartments For Rent In San Antonio TX Near University of the Incarnate Word",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near University of the Incarnate Word",
      "h2_subtitle": "Discover luxury living at Alon at Castle Hills. Our apartments offer upscale amenities and are conveniently located near University of the Incarnate Word.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near University of the Incarnate Word feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Spend your afternoons relaxing with friends in our exclusive resident clubhouse, or cool off on hot days with a dip in the resort-style swimming pool. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent In San Antonio TX Near University of the Incarnate Word",
      "seo_description": "Discover luxury living at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near University of the Incarnate Word offer upscale amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-san-antonio-tx-near-st-marys-university",
      "search_query": "Apartments For Rent In San Antonio TX Near St. Mary's University",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near St. Mary's University",
      "h2_subtitle": "Experience luxury living at Alon at Castle Hills. Our apartments offer upscale amenities and are conveniently located near St. Mary's University.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near St. Mary's University feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Spend your afternoons relaxing with friends in our exclusive resident clubhouse, or cool off on hot days with a dip in the resort-style swimming pool. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent In San Antonio TX Near St. Mary's University",
      "seo_description": "Experience luxury living at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near St. Mary's University offer upscale amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-san-antonio-tx-near-koehler-house",
      "search_query": "Apartments For Rent In San Antonio TX Near The Koehler House",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near The Koehler House",
      "h2_subtitle": "Discover luxury living at Alon at Castle Hills. Our apartments offer upscale amenities and are conveniently located near The Koehler House.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near The Koehler House feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Spend your afternoons relaxing with friends in our exclusive resident clubhouse, or cool off on hot days with a dip in the resort-style swimming pool. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent In San Antonio TX Near The Koehler House",
      "seo_description": "Discover luxury living at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near The Koehler House offer upscale amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-san-antonio-tx-near-northwest-vista",
      "search_query": "Apartments For Rent In San Antonio TX Near Northwest Vista College",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near Northwest Vista College",
      "h2_subtitle": "Experience luxury living at Alon at Castle Hills. Our apartments offer upscale amenities and are conveniently located near Northwest Vista College.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near Northwest Vista College feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Spend your afternoons relaxing with friends in our exclusive resident clubhouse, or cool off on hot days with a dip in the resort-style swimming pool. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent In San Antonio TX Near Northwest Vista College",
      "seo_description": "Experience luxury living at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near Northwest Vista College offer upscale amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-san-antonio-tx-near-churchill-high",
      "search_query": "Apartments For Rent In San Antonio TX Near Churchill High School",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near Churchill High School",
      "h2_subtitle": "Discover family-friendly living at Alon at Castle Hills. Our apartments offer upscale amenities and are conveniently located just 2.8 km from Churchill High School.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near Churchill High School are perfect for families looking for a convenient and upscale lifestyle. With available one and two bedroom floor plans, you can find the perfect space for your family. Our apartments feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Spend your afternoons relaxing with friends in our exclusive resident clubhouse, or cool off on hot days with a dip in the resort-style swimming pool. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent In San Antonio TX Near Churchill High School",
      "seo_description": "Discover family-friendly living at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near Churchill High School offer upscale amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5735011386916864",
      "source": "custom",
      "page_item_url": "apartments-for-rent-san-antonio-tx-near-eisenhower",
      "search_query": "Apartments For Rent In San Antonio TX Near Eisenhower Middle School",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near Eisenhower Middle School",
      "h2_subtitle": "Discover family-friendly living at Alon at Castle Hills. Our apartments offer upscale amenities and are conveniently located just 2.2 km from Eisenhower Middle School.",
      "page_copy": "Wake up to modern luxury living when you begin each day at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near Eisenhower Middle School are ideal for families seeking a convenient and upscale lifestyle. With available one and two bedroom floor plans, you can find the perfect space for your family. Our apartments feature high-end amenities like a private patio or balcony, walk-in closets, and a spacious chef’s kitchen. Beyond the doors of your air-conditioned apartment, you’ll love our vibrant community’s amenities. Spend your afternoons relaxing with friends in our exclusive resident clubhouse, or cool off on hot days with a dip in the resort-style swimming pool. In the evenings, enjoy your favorite flicks in our onsite movie theater. There are so many ways to celebrate each day at Alon at Castle Hills, you may never want to leave home again.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
      "featured_image_media": {
        "alt_text": "ALON at Castle Hills Premier Apartments monument sign with brick pillars and landscaping.",
        "public_id": "019f6c0b-617e-7450-9c8c-6bf38bdfe295",
        "storage_key": "property/5735011386916864/019f6c0b-617e-7450-9c8c-6bf38bdfe295.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
      "blank_image_media": {
        "alt_text": "Image not available",
        "public_id": "019f6c0b-6c75-76a0-a8e5-9ee9efc6717c",
        "storage_key": "property/5735011386916864/019f6c0b-6c75-76a0-a8e5-9ee9efc6717c.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Alon at Castle Hills | Apartments For Rent In San Antonio TX Near Eisenhower Middle School",
      "seo_description": "Discover family-friendly living at Alon at Castle Hills. Our apartments for rent in San Antonio, TX, near Eisenhower Middle School offer upscale amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2135"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376470986"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a14\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a14\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4489149"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KV26CGQ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://alonatcast.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443218213"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/r5v5269mvny"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/3e4e2286-24a2-4f82-b0b4-bc386e56279d"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "210-791-6714"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IngrRVRqK055ZnRIVUxzTE1vVHpuK3c9PSIsInZhbHVlIjoiSDB4L09zKzVpM1VXb1BJRmNtcVVzQT09IiwibWFjIjoiMWZjYzNkYTdiNWQyYzI0MDk1NDI0YjE4YmMxNmEwNzdjMDcxOTk5OGNhY2Y5NWYzZTBkN2Q1Nzc3NmQzMDdiZCJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2135",
  "custom_repli_id": "2376470986",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a14\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a14\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4489149",
  "custom_google_gtm_id": "GTM-KV26CGQ",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://alonatcast.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443218213",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/r5v5269mvny",
  "custom_self_guided_tour_url": "https://selftournow.com/property/3e4e2286-24a2-4f82-b0b4-bc386e56279d",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "210-791-6714",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IngrRVRqK055ZnRIVUxzTE1vVHpuK3c9PSIsInZhbHVlIjoiSDB4L09zKzVpM1VXb1BJRmNtcVVzQT09IiwibWFjIjoiMWZjYzNkYTdiNWQyYzI0MDk1NDI0YjE4YmMxNmEwNzdjMDcxOTk5OGNhY2Y5NWYzZTBkN2Q1Nzc3NmQzMDdiZCJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-09T16:41:00.449Z';
